
import React, { useState, useEffect, useRef } from "react";
import { Line } from "react-chartjs-2";
import Chart from "chart.js/auto";
import { deflate, inflate } from "pako";
import loading_ from "../Assets2/loading.gif";
import bg1 from "../Assets2/screenshot1.png";
import bg2 from "../Assets2/screenshot2.png";
import bg3 from "../Assets2/screenshot3.png";
import bg4 from "../Assets2/screenshot4.png";
import bg5 from "../Assets2/screenshot5.png";
import bg6 from "../Assets2/screenshot6.png";
import bg7 from "../Assets2/screenshot7.png";
import bg8 from "../Assets2/screenshot8.png";
import bg9 from "../Assets2/screenshot9.png";
import bg10 from "../Assets2/screenshot10.png";
import bg11 from "../Assets2/screenshot11.png";
import bg12 from "../Assets2/screenshot12.png";
import "./CSS/Page_Mnagment.css";
import BtnCellRenderer2 from "./BtnCellRenderer2.jsx";
import { Link } from "react-router-dom";
import "./CSS/All.css";
import yuzonbir from "../Assets/a_1.png";
import yuzonikş from "../Assets/a_2.png";
import pcc from "../Assets/a_3.png";
import elec_generator from "../Assets/a_4.png";
import air_chiller_2 from "../Assets/a_5.png";
import boiler from "../Assets/a_6.png";
import chiller from "../Assets/a_7.PNG";
import chiller2 from "../Assets/a_8.jpg";
import esanjor from "../Assets/a_9.PNG";
import valve_png from "../Assets/a_10.png";
import a from "../Assets/a_11.png";
import b from "../Assets/a_12.png";
import c from "../Assets/a_13.png";
import d from "../Assets/a_14.png";
import e from "../Assets/a_15.png";
import f from "../Assets/a_16.png";
import g from "../Assets/a_17.png";
import h from "../Assets/a_18.png";
import i from "../Assets/a_19.png";
import j from "../Assets/a_20.png";
import k from "../Assets/a_21.png";
import l from "../Assets/a_22.png";
import m from "../Assets/a_23.png";
import n from "../Assets/a_24.PNG";
import b2 from "../Assets/a_25.PNG";
import c2 from "../Assets/a_26.PNG";
import d2 from "../Assets/a_27.PNG";
import e2 from "../Assets/a_28.PNG";
import water_chiller from "../Assets/a_29.png";
import analy from "../Assets/6744989.png";
import speedr from "../Assets/3563394.png";
import steam from "../Assets/1724304.png";
import sun_energy from "../Assets/4114970.png";
import redbell from "../Assets/559343.png";
import pontoon from "../Assets/1505455.png";
import carbon_foot from "../Assets/7822060.png";
import { useDispatch, useSelector } from "react-redux";
import Store from "../Store/Store";
import {
    add_page_name,
    set_render_items_toolbox,
    set_toolbox,
    set_temp_id,
    set_white_space,
} from "../Action/Action";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import GaugeChart from "react-gauge-chart";
import Draggable from "react-draggable";
import { render } from "react-dom";

const LineChart = ({ data, labels, yAxisName }) => {
    const chartData = {
        labels: labels,
        datasets: [
            {
                label: "Random Data",
                data: data,
                fill: false,
                borderColor: "rgb(75, 192, 192)",
                tension: 0.1,
            },
        ],
    };
    const options = {
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Zaman",
                },
            },
            y: {
                title: {
                    display: true,
                    text: yAxisName,
                },
            },
        },
    };

    return (
        <div>
            <Line options={options} data={chartData} />
        </div>
    );
};

const All3 = (props) => {
    const [tag_values, Set_tag_values] = useState([]);
    const history = useHistory();
    const [loading, SetLoading] = useState(true);

    const [min, SetMin] = useState(0);
    const [max, SetMax] = useState(0);
    const [images, Set_images] = useState([])

    const [old_items3, Set_old_items3] = useState([])

    const OnChangeMin = (e) => {
        SetMin(e.target.value);
    };

    const [pop_up_widget, Set_pop_up_widget] = useState([]);

    const [temp_id, Set_temp_id] = useState("")

    const OnChangeMax = (e) => {
        SetMax(e.target.value);
    };

    useEffect(() => {
        console.log(props.white_space_, props.toolbox);
        if (props.white_space_.length > 0) {
            var newdata = items3;
            for (let i = 0; i < props.white_space_.length; i++) {
                if (props.white_space_[i].type !== "pop_up_widget") newdata.push(props.white_space_[i]);

            }
            console.log(newdata);

            Set_items3(newdata);
        }
    }, [props.white_space_]);

    useEffect(() => {
        console.log(props.white_space_3);
        if (props.white_space_3.length > 0) {
            var newdata = [];
            for (let i = 0; i < props.white_space_3.length; i++) {
                console.log(props.white_space_3[i]);
                newdata.push(props.white_space_3[i]);
            }
            newdata.pop()

            Set_pop_up_widget(newdata)
            Set_items3((prevArray) => [...prevArray, newdata])
        }
    }, [props.white_space_3]);

    const [page_name, Set_page_name] = useState("")

    //page id
    const [page_id, Set_page_id] = useState(0)

    useEffect(() => {
        var current_path = window.location.pathname;
        var temp_items3 = [];

        current_path = current_path.slice(1, current_path.length)
        var current_path_index = current_path.indexOf("/")
        current_path = current_path.slice(current_path_index, current_path.length - 4)
        var page_id = current_path.slice(1, current_path.length)

        Set_page_id(Number(page_id))
        var _pages = props.pages
        var bg;
        var img_temp = []
        console.log(_pages);


        function isWidgetWithIdInArray(id, array) {
            return array.some(item => item.id === id);
        }

        _pages.forEach((i) => {
            if (i.pageId === Number(page_id)) {
                console.log(i);

                Set_page_name(i.pageName)

                if (i.details.Pages[0].bgs && i.details.Pages[0].bgs.length > 0) {
                    bg = i.details.Pages[0].bgs[0].src
                }

                i.details.Pages[0].images.forEach(j => {
                    console.log(j);
                    img_temp.push(j)
                })
                i.details.Pages[0].widgets.forEach(j => {
                    console.log(j);
                    if (j.type === "pop_up_widget") {
                        temp_items3.push(j)
                        if (!isWidgetWithIdInArray(j.id, pop_up_widget)) {
                            Set_pop_up_widget((PrevArray) => [...PrevArray, j.elementDetails.pop_up]);
                        }
                    }

                    temp_items3.push(j)



                })
                i.details.Pages[0].white_spaces.forEach(j => {
                    temp_items3.push(j)
                })
            }
        })

        Set_old_items3(temp_items3)
        Set_images(img_temp)
        if (loading !== true) {
            SetBG(bg)
            document.querySelector(
                "section.toolbox_section_active"
            ).style.backgroundImage = `url(${bg})`;
            document.querySelector(
                "section.toolbox_section_active"
            ).style.backgroundRepeat = "no-repeat";
            document.querySelector("section.toolbox_section_active").style.backgroundSize =
                "60%";
            document.querySelector(
                "section.toolbox_section_active"
            ).style.backgroundPosition = "center 200px";
        }
    }, [props.pages, loading])

    useEffect(() => {
        if (props.current_path !== "") {
            console.log(props.toolbox);
            Set_items3(props.toolbox);
            if (pages.length > 0) {
                setTimeout(() => {
                    open_toolbox();
                }, 1610);
            } else {
                setTimeout(() => {
                    open_toolbox();
                }, 610);
            }
        }
    }, [window.location.pathname]);

    useEffect(() => {
        console.log(props.white_space_, props.toolbox);
        if (props.white_space_.length > 0) {
            var newdata = items3;
            for (let i = 0; i < props.white_space_.length; i++) {
                newdata.push(props.white_space_[i]);
            }
            console.log(newdata);

            Set_items3(newdata);
        }
    }, [props.white_space_]);

    const [inputValue3, setInputValue3] = useState("");
    const [selectedOption3, setSelectedOption3] = useState("Select");
    const [isActive3, setIsActive3] = useState(false);
    const [inputValue1, setInputValue1] = useState("");
    const [selectedOption1, setSelectedOption1] = useState("Select");
    const [isActive1, setIsActive1] = useState(false);
    const [inputValue2, setInputValue2] = useState("");
    const [selectedOption2, setSelectedOption2] = useState("Select");
    const [isActive2, setIsActive2] = useState(false);
    const [inputValue4, setInputValue4] = useState("");
    const [selectedOption4, setSelectedOption4] = useState("Select");
    const [isActive4, setIsActive4] = useState(false);

    const handleDropdownClick3 = () => {
        setIsActive3(!isActive3);
    };

    const handleDropdownBlur3 = () => {
        setIsActive3(false);
    };
    const handleOptionClick3 = (optionValue) => {
        setSelectedOption3(optionValue);
        setInputValue3(optionValue);
    };

    const handleDropdownClick1 = () => {
        setIsActive1(!isActive1);
    };

    const decompressData = (compressedData) => {
        try {
            const decompressed = inflate(compressedData, { to: "string" });
            console.log(decompressed);
            return decompressed;
        } catch (error) {
            console.error("Decompression error:", error);
        }
    };

    const compressData = (data) => {
        try {
            const compressed = deflate(data, { to: "string" });
            console.log(compressed);
            decompressData(compressed);
            return compressed;
        } catch (error) {
            console.error("Compression error:", error);
        }
    };

    const handleDropdownBlur1 = () => {
        setIsActive1(false);
    };
    const handleOptionClick1 = (optionValue) => {
        setSelectedOption1(optionValue);
        setInputValue1(optionValue);
    };
    const handleDropdownClick4 = () => {
        setIsActive4(!isActive4);
    };

    const handleDropdownBlur4 = () => {
        setIsActive4(false);
    };
    const handleOptionClick4 = (optionValue) => {
        setSelectedOption4(optionValue);
        setInputValue4(optionValue);
    };
    const handleDropdownClick2 = () => {
        setIsActive2(!isActive2);
    };

    const handleDropdownBlur2 = () => {
        setIsActive2(false);
    };
    const handleOptionClick2 = (optionValue) => {
        setSelectedOption2(optionValue);
        setInputValue2(optionValue);
    };
    const [data, setData] = useState([]);

    const exampleData = [
        { x: 1, y: 10 },
        { x: 2, y: 20 },
        { x: 3, y: 15 },
        // Add more data points as needed
    ];

    const [selected_html_tag, Set_selected_html_tag] = useState(null);

    const [selected_tags, Set_selected_tags] = useState([]);

    const [items3_3, Set_items3_3] = useState([]);

    const [ls_items, Set_ls_items] = useState([]);

    useEffect(() => {
        console.log(selected_html_tag);
    }, [selected_html_tag]);

    useEffect(() => {
        const componentDidMount = async () => {
            let items = localStorage.getItem("items");
            let json_items = JSON.parse(items);
            if (json_items) {
                Set_ls_items(json_items);
            }
            if (props._tag_ids && props._tag_ids.length > 0) {
                try {
                    const request = await fetch(
                        "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                        {
                            headers: {
                                "Content-Type": "application/json",
                                accept: "application/json",
                            },
                            method: "POST",
                            body: JSON.stringify(props._tag_ids),
                        }
                    );
                    const response = await request.json();

                    Set_tag_values(response);
                } catch (err) {
                    console.log(err);
                }
            }
        };
        componentDidMount();
    }, [props._tag_ids]);

    const [text_state, SetText_State] = useState(0);
    const [tag_text, Settag_text] = useState(0);
    const [button_state, Setbutton_state] = useState(0);
    const [resim_state, Setresim_state] = useState(0);

    const cardBodyRef = useRef(null);

    const [render_items, Setrender_items] = useState([]);

    const [items3, Set_items3] = useState(props.toolbox);


    let tags_ = [];

    const [tags, SetTags] = useState([]);

    const chartData = {
        labels: data.map((point) => point.x),
        datasets: [
            {
                label: "Trend Data",
                data: data.map((point) => point.y),
                fill: false,
                borderColor: "rgba(75, 192, 192, 1)",
                borderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                title: {
                    display: true,
                    text: "X-axis Label", // Replace with your X-axis label
                },
            },
            y: {
                title: {
                    display: true,
                    text: "Y-axis Label", // Replace with your Y-axis label
                },
            },
        },
    };

    useEffect(() => {
        console.log(items3);
    }, [items3]);

    const [selectedImage, setSelectedImage] = useState([]);
    const [selectedImagebg, setSelectedImagebg] = useState([]);

    let led = false;

    const [bg, SetBG] = useState([]);
    const [main_title, Set_Main_title] = useState("");
    const [main_title2, Set_Main_title2] = useState("");

    const [items, SetItems] = useState([]);

    const proxyUrl = "https://cors-anywhere.herokuapp.com/";

    const [image, setImage] = useState([]);
    const [widget, setWidget] = useState([]);
    const [text, SetText] = useState("");

    let link_widget = [];
    let gaugeWidget = [];
    let names_widget = [];
    let names_widget2 = [];
    let trends_widget = [];

    function encodeBase64FromArray(array) {
        let binary = "";
        for (let i = 0; i < array.length; i++) {
            binary += String.fromCharCode(array[i]);
        }
        return btoa(binary);
    }

    const [gaugeValueMax, SetgaugevalueMax] = useState(null);
    const [gaugeValue, Setgaugevalue] = useState(null); // A value between 0 and 1

    const gaugeConfig = {
        // Configuration options (optional)
        // For example: arcWidth: 0.1, arcPadding: 0.02, etc.
    };

    const onChangeGaugeMax = (e) => {
        SetgaugevalueMax(Number(e.target.value));
    };
    const [popup_state, Set_popup_state] = useState({})


    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = async (event) => {
            let long_string = event.target.result;

            setSelectedImage([
                ...selectedImage,
                {
                    src: long_string,
                    w: 280,
                    h: 320,
                    id: 110 - selectedImage.length,
                    x: Math.floor(Math.random() * 200),
                    y: Math.floor(Math.random() * 200),
                },
            ]);
        };

        reader.readAsDataURL(file);
    };

    const handleImageUploadbg = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = async (event) => {
            let long_string = event.target.result;

            setSelectedImagebg([
                {
                    src: long_string,
                    id: 112 - selectedImage.length,
                },
            ]);
        };

        reader.readAsDataURL(file);
    };


    const OnFormSubmit = async (e) => {
        e.preventDefault();

        console.log(items3, "aaaaawwww");


        try {
            if (page_name === "") {
                alert("Lütfen sayfa ismi giriniz!");
            } else {
                control = true;
                SetLoading(true);
                await Store.dispatch(add_page_name(page_name));
                e.target.parentElement.firstElementChild.value = "";
                let images_ = [];
                let widgets_ = [];
                let background_ = [];
                let white_spaces = [];

                let new_array = items3;

                new_array.forEach((item) => {
                    console.log(item);
                    if (item.type === "image") {
                        var x = Math.floor(Math.random() * 420);
                        var y = Math.floor(Math.random() * 420);

                        images_.push({
                            id: item.id,
                            x: x,
                            y: y,
                            w: 200,
                            h: 220,
                            src: item.elementDetails.src,
                        });

                    } else if (item.type === "bg") {
                        console.log(item);
                        background_.push({ id: item.id, src: item.elementDetails.src });
                    }else if(item.type==="tag") {
                        widgets_.push({
                            elementDetails: { text: item.elementDetails.text,tagId:item.elementDetails.tagId },
                            type: "tag",
                            id: item.id,
                            x: item.x,
                            y: item.y,
                        });
                    }
                    else if (item.type === "text") {
                        widgets_.push({
                            title_widget: item.elementDetails.text,
                            type: "text",
                            id: item.id,
                            x: item.x,
                            y: item.y,
                        });
                    } else if (item.type === "title") {
                        widgets_.push({
                            title_widget: item.elementDetails.text,
                            type: "title",
                            id: item.id,
                            x: item.x,
                            y: item.y,
                        });
                    } else if (item.type === "gauge") {
                        widgets_.push({
                            id: item.id,
                            type: "gauge",
                            tagId: item.elementDetails.tagId,
                            tagName: item.elementDetails.tagName,
                            max_value: item.elementDetails.max_value,
                            x: item.x,
                            y: item.y,
                        });
                    } else if (item.type === "trend") {
                        console.log(item);

                        widgets_.push({
                            id: item.id,
                            type: "trend",
                            tagId: item.elementDetails.tagId,
                            tagName: item.elementDetails.tagName,
                            axis_name: item.elementDetails.axis_name,
                            x: item.x,
                            y: item.y,
                        });
                    } else if (item.type === "label") {
                        widgets_.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "label",
                            main_title: item.main_title,
                            tagId: item.tagId,
                            text: item.text,
                            led: item.led,
                            max: item.max,
                            min: item.min,
                        });
                    } else if (item.type === "select") {
                        widgets_.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "select",
                            tagId: item.elementDetails.id,
                            tagName: item.elementDetails.text,
                        });
                    } else if (item.type === "button") {
                        widgets_.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "button",
                            page_name: item.elementDetails.text,
                        });
                    } else if (item.type === "white_space") {
                        console.log(item);
                        white_spaces.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "white_spaces",
                            elementDetails: item.elementDetails,
                        });
                    } else if (item.type === "text_box") {
                        widgets_.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "text_box",
                            elementDetails: item.elementDetails,
                        });

                    } else if (item.type === "pop_up_widget") {
                        pop_up_widget.forEach(item_ => {
                            if (item_.id === item.id) {
                                widgets_.push({
                                    id: item.id,
                                    x: item.x,
                                    y: item.y,
                                    type: "pop_up_widget",
                                    elementDetails: { text: item.elementDetails.text, tagId: item.elementDetails.tagId, pop_up: item_ },
                                })
                            }
                        })

                    }
                });

                let newdata2 = old_items3;
                console.log(newdata2, pop_up_widget);

                newdata2.forEach((a) => {

                    console.log(a);


                    if (a.src && a.x) {
                        var x = Math.floor(Math.random() * 820);
                        var y = Math.floor(Math.random() * 720);

                        images_.push({
                            id: a.id,
                            x: x,
                            y: y,
                            w: 200,
                            h: 220,
                            src: a.elementDetails.src,
                        });
                    }

                    if (a.type === "text") {
                        widgets_.push({
                            title_widget: a.title_widget,
                            type: "text",
                            id: a.id,
                            x: a.x,
                            y: a.y,
                        });
                    } else if (a.type === "title") {
                        widgets_.push({
                            title_widget: a.title_widget,
                            type: "title",
                            id: a.id,
                            x: a.x,
                            y: a.y,
                        });
                    } else if (a.type === "gauge") {
                        widgets_.push({
                            id: a.id,
                            type: "gauge",
                            tagId: a.tagId,
                            tagName: a.tagName,
                            max_value: a.max_value,
                            x: a.x,
                            y: a.y,
                        });
                    } else if (a.type === "trend") {
                        console.log(a);

                        widgets_.push({
                            id: a.id,
                            type: "trend",
                            tagId: a.tagId,
                            tagName: a.tagName,
                            axis_name: a.axis_name,
                            x: a.x,
                            y: a.y,
                        });
                    } else if (a.type === "label") {
                        widgets_.push({
                            id: a.id,
                            x: a.x,
                            y: a.y,
                            type: "label",
                            main_title: a.main_title,
                            tagId: a.tagId,
                            text: a.text,
                            led: a.led,
                            max: a.max,
                            min: a.min,
                        });
                    } else if (a.type === "select") {
                        widgets_.push({
                            id: a.id,
                            x: a.x,
                            y: a.y,
                            type: "select",
                            tagId: a.tagId,
                            tagName: a.tagName,
                        });
                    } else if (a.type === "button") {
                        widgets_.push({
                            id: a.id,
                            x: a.x,
                            y: a.y,
                            type: "button",
                            page_name: a.page_name,
                        });
                    } else if (a.type === "white_space") {
                        console.log(a);
                        white_spaces.push({
                            id: a.id,
                            x: a.x,
                            y: a.y,
                            type: "white_spaces",
                            elementDetails: a.elementDetails,
                        });
                    } else if (a.type === "text_box") {
                        widgets_.push({
                            id: a.id,
                            x: a.x,
                            y: a.y,
                            type: "text_box",
                            elementDetails: { text: a.elementDetails.text }
                        });
                    } else if (a.type === "pop_up_widget") {
                        pop_up_widget.forEach(item_ => {
                            console.log(item_, a);
                            if (item_.id === a.id) {
                                widgets_.push({
                                    id: a.id,
                                    x: a.x,
                                    y: a.y,
                                    type: "pop_up_widget",
                                    elementDetails: { text: a.elementDetails.text, tagId: a.elementDetails.tagId, pop_up: item_ },
                                })
                            }
                        })

                    }else if(a.type==="tag") {
                        widgets_.push({
                            elementDetails: { text: a.elementDetails.text,tagId:a.elementDetails.tagId },
                            type: "tag",
                            id: a.id,
                            x: a.x,
                            y: a.y,
                        });
                    }
                })


                let x = 0;
                let new_white_spaces = [];


                console.log(widgets_);


                let set_sql_items = {
                    Pages: [
                        {
                            text: page_name,
                            images: images_,
                            widgets: widgets_,
                            white_spaces: white_spaces,
                            bgs: background_,
                        },
                    ],
                };
                console.log(set_sql_items);
                console.log(JSON.stringify(set_sql_items));
                try {
                    const req_ = await fetch(
                        `httpS://rmmsapi.azurewebsites.net/api/pages/AddPage`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                accept: "application/json",
                            },
                            body: JSON.stringify({
                                PageId: page_id,
                                userId: props.auth_reducer,
                                companyId: props.company_id,
                                pageName: page_name,
                                details: JSON.stringify(set_sql_items),
                            }), // Convert the body object to a JSON string
                        }
                    );
                    const response = await req_.json();
                } catch (err) {
                    console.log(err, "aüaüaüaüaüaüüaaü");
                }
                // add_pages_names(text)
            }
        } catch (err) {
            console.log(err);
        } finally {
            Store.dispatch(set_render_items_toolbox([]));
            Store.dispatch(set_white_space([]));
            Store.dispatch(set_toolbox([]));
            history.push(`/`)
            window.location.reload();
        }
    };

    // const add_pages_names = (text_) => {
    //     console.log(text);
    //     databasefirebase.ref(`${props.auth_reducer}/Pages_Names`).push(text_)

    // }

    const input_text = (e) => {
        e.preventDefault();

        let text_ = e.target.value;
        if (text_.includes("_")) {
            alert("Page name cannot include special characters!");
            text_ = text_.replaceAll("_", " ");
        } else if (text_.includes("/")) {
            alert("Page name cannot include special characters!");
            text_ = text_.replaceAll("/", "");
        } else {
            SetText(text_);
        }
    };

    var control = loading;

    const [pages, SetPages] = useState(props.pages);

    useEffect(() => {
        if (props.pages.length > 0) {
            SetPages(props.pages);
            var list__ = props.pages;

            setTimeout(() => {
                SetLoading(false);
                control = false;

                SetItems(list__);
            }, 1200);

            setData(exampleData);
        } else {
            setTimeout(() => {
                SetLoading(false);
                control = false;
            }, 600);
        }
    }, [props.pages]);

    useEffect(() => {
        if (!control) {
            console.log(control);
        }
    }, [control]);

    const delete_page = async (e) => {
        e.preventDefault();

        control = true;
        SetLoading(true);

        var selected_id =
            e.target.parentElement.parentElement.firstElementChild.firstElementChild
                .textContent;
        console.log(selected_id);
        //widgets and images db

        // just pages name db

        var confirm = window.confirm(
            "Bu sayfayı silmek istediğinizden emin misiniz?"
        );

        var newlist = []; //for widgets and images
        var newList2 = []; // for pages names

        if (confirm) {
            if (props.pages) {
                props.pages.forEach(async (item) => {
                    if (String(item.pageId) === selected_id) {
                        try {
                            const req_ = await fetch(
                                `https://app-rmmsapi.azurewebsites.net/api/pages/DeletePage`,
                                {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        accept: "application/json",
                                    },
                                    body: JSON.stringify({
                                        PageId: item.pageId,
                                    }), // Convert the body object to a JSON string
                                }
                            );
                            const response = await req_.json();
                            console.log(response);
                        } catch (err) {
                            console.log(err, "aüaüaüaüaüaüüaaü");
                        } finally {
                            window.location.reload();
                        }
                    }
                });
            }

            e.target.parentElement.parentElement.parentElement.style.display = "none";
        }
    };

    const images_click = (e) => {
        e.preventDefault();
        let section = document.querySelector("section.all_page_management");
        if (section.classList.contains("section_dark")) {
            section.classList.remove("section_dark");
        }
        const images = document.querySelector(".all_hidden_images");
        images.classList.toggle("all_hidden_images_active");
        if (
            document
                .querySelector(".add_widget_part")
                .classList.contains("add_widget_part_active")
        ) {
            document
                .querySelector(".add_widget_part")
                .classList.remove("add_widget_part_active");
        } else if (
            document
                .querySelector("#sxxch-bg-31")
                .classList.contains("all_hidden_backgrounds_active")
        ) {
            document
                .querySelector("#sxxch-bg-31")
                .classList.remove("all_hidden_backgrounds_active");
        }
    };
    useEffect(() => {
        console.log(items3, "iterms3");
    }, [items3]);
    const widgets_click = (e) => {
        e.preventDefault();
        let section = document.querySelector("section.all_page_management");
        section.classList.toggle("section_dark");
        const widgets = document.querySelector(".select_widget_type");
        widgets.classList.toggle("select_widget_type_active");
        widgets.style.display = "grid";
        widgets.style.opacity = "1";
        if (
            document
                .querySelector("#sxxc-45-ghutr")
                .classList.contains("all_hidden_images_active")
        ) {
            document
                .querySelector("#sxxc-45-ghutr")
                .classList.remove("all_hidden_images_active");
        } else if (
            document
                .querySelector("#sxxch-bg-31")
                .classList.contains("all_hidden_backgrounds_active")
        ) {
            document
                .querySelector("#sxxch-bg-31")
                .classList.remove("all_hidden_backgrounds_active");
        }
    };

    const default_widget_click = (e) => {
        const widgets_defult = document.querySelector(".add_widget_part");
        widgets_defult.style.opacity = "1";
        widgets_defult.style.zIndex = "100000000";

        widgets_defult.classList.toggle("add_widget_part_active");
        const widgets = document.querySelector(".select_widget_type");
        widgets.style.opacity = "0";
    };
    const background_click = (e) => {
        e.preventDefault();
        let section = document.querySelector("section.all_page_management");
        if (section.classList.contains("section_dark")) {
            section.classList.remove("section_dark");
        }
        const bgs = document.querySelector(".all_hidden_backgrounds");
        bgs.classList.toggle("all_hidden_backgrounds_active");
        if (
            document
                .querySelector("#sxxc-45-ghutr")
                .classList.contains("all_hidden_images_active")
        ) {
            document
                .querySelector("#sxxc-45-ghutr")
                .classList.remove("all_hidden_images_active");
        } else if (
            document
                .querySelector(".add_widget_part")
                .classList.contains("add_widget_part_active")
        ) {
            document
                .querySelector(".add_widget_part")
                .classList.remove("add_widget_part_active");
        }
    };

    useEffect(() => {
        Setrender_items(props.render_items_length);
    }, []);

    useEffect(() => {
        console.log(render_items);
    }, [render_items]);

    const [labels_ww, Set_labels_ww] = useState(0);

    function add_widget_plus(e) {
        let title =
            e.target.parentElement.firstElementChild.nextElementSibling
                .nextElementSibling.firstElementChild.value;
        let value_ = document.querySelector("#default_widget_value_id");
        let main_title_ = main_title;
        var newdata = items3;
        Set_labels_ww(labels_ww + 1);

        let min_ = document.querySelector("#min_default").value;
        let max_ = document.querySelector("#max_default").value;
        let alarm_ = document.querySelector("#alarm_default").value;

        console.log(min_, max_);

        if (title !== "" && value_ !== "") {
            newdata.push({
                id: labels_ww + render_items.length,
                x: Math.floor(Math.random() * 100),
                y: Math.floor(Math.random() * 300),
                type: "label",
                min: Number(min_),
                max: Number(max_),
                alarm: Number(alarm_),
                text: title,
                tagId: value_.options[value_.selectedIndex].value,
                led: `${led}`,
                main_title: main_title_ !== "" ? main_title_ : "",
            });
            console.log(newdata);
            SetTags((prevArray) => [
                ...prevArray,
                { tagId: value_.options[value_.selectedIndex].value },
            ]);
            tags_.push(value_.options[value_.selectedIndex].value);
            led = false;
        }
        console.log(newdata);
        Set_items3(newdata);
        Set_Main_title("");
        title = "";
    }
    function add_widget_plus2(e) {
        if (selectedOption1 !== "Select") {
            let title = selectedOption1;
            let value_ = document.querySelector("#select_value_id_1");
            names_widget2.push({
                title_widget: title,
                tagId: value_.options[value_.selectedIndex].value,
            });
            SetTags((prevArray) => [
                ...prevArray,
                { tagId: value_.options[value_.selectedIndex].value },
            ]);
            tags_.push(value_.options[value_.selectedIndex].value);
        }
        if (selectedOption2 !== "Select") {
            let title = selectedOption2;
            let value_ = document.querySelector("#select_value_id_2");
            names_widget2.push({
                title_widget: title,
                tagId: value_.options[value_.selectedIndex].value,
            });
            SetTags((prevArray) => [
                ...prevArray,
                { tagId: value_.options[value_.selectedIndex].value },
            ]);
            tags_.push(value_.options[value_.selectedIndex].value);
        }
        if (selectedOption3 !== "Select") {
            let title = selectedOption3;
            let value_ = document.querySelector("#select_value_id_3");
            names_widget2.push({
                title_widget: title,
                tagId: value_.options[value_.selectedIndex].value,
            });
            SetTags((prevArray) => [
                ...prevArray,
                { tagId: value_.options[value_.selectedIndex].value },
            ]);
            tags_.push(value_.options[value_.selectedIndex].value);
        }
        if (selectedOption4 !== "Select") {
            let title = selectedOption4;
            let value_ = document.querySelector("#select_value_id_4");
            names_widget2.push({
                title_widget: title,
                tagId: value_.options[value_.selectedIndex].value,
            });
            SetTags((prevArray) => [
                ...prevArray,
                { tagId: value_.options[value_.selectedIndex].value },
            ]);
            tags_.push(value_.options[value_.selectedIndex].value);
        }
    }
    function close_widget_add(e) {
        e.preventDefault();
        document.querySelectorAll("#k-w-t").forEach((i) => {
            i.style.opacity = "0";
        });
        const widgets = document.querySelector(".add_widget_part");
        widgets.classList.toggle("add_widget_part_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }

    const bg_add = async (e) => {
        e.preventDefault();
        let section = document.querySelector("section.all_page_management");
        if (section.classList.contains("section_dark")) {
            section.classList.remove("section_dark");
        }

        const selected_bg =
            e.target.parentElement.id || e.target.parentElement.parentElement.id;
        await SetBG([...bg, { id: selected_bg }]);
    };

    const widget_add = async (e) => {
        e.preventDefault();
        console.log(e.target.parentElement);

        var x = Math.floor(Math.random() * 420);
        var y = Math.floor(Math.random() * 420);

        if (e.target.parentElement.classList.contains("default_widget")) {
            setWidget([
                ...widget,
                {
                    names_widget: names_widget,
                    tagId: tags_[0],
                    x: x,
                    y: y,
                    id: widget.length + 41,
                    main_title: main_title,
                    fontSize: 14.56,
                    fontFamily: "Arial, sans-serif",
                },
            ]);
            Set_Main_title("");
            names_widget = [];
            document.querySelectorAll("#gdu-3").forEach((i) => {
                i.value = "";
            });
            tags_ = [];
        } else if (
            e.target.parentElement.classList.contains("input_select_widget")
        ) {
            setWidget([
                ...widget,
                {
                    names_widget2: names_widget2,
                    tagId: tags_[0],
                    x: x,
                    y: y,
                    id: widget.length + 41,
                    main_title: main_title2,
                    fontSize: 14.56,
                    fontFamily: "Arial, sans-serif",
                },
            ]);
            Set_Main_title2("");
            names_widget2 = [];

            tags_ = [];
        } else if (e.target.parentElement.classList.contains("link_widget")) {
            console.log(link_widget, "1111");
            setWidget([
                ...widget,
                {
                    links_widget: link_widget,
                    x: x,
                    y: y,
                    id: widget.length + 41,
                    fontSize: 14.56,
                    fontFamily: "Arial, sans-serif",
                },
            ]);
            link_widget = [];
        } else if (e.target.parentElement.classList.contains("gauge_widget")) {
            setWidget([
                ...widget,
                {
                    gauges_widget: gaugeWidget,
                    tagId: tags_[0],
                    x: x,
                    y: y,
                    id: widget.length + 41,
                    fontSize: 14.56,
                    fontFamily: "Arial, sans-serif",
                },
            ]);
            document.querySelectorAll("#cm0-x7y").forEach((i) => {
                i.value = "";
            });
            tags_ = [];
        } else if (e.target.parentElement.classList.contains("trend_widget")) {
            setWidget([
                ...widget,
                {
                    trends_widget: trends_widget,
                    tagId: tags_[0],
                    x: x,
                    y: y,
                    id: widget.length + 41,
                    fontSize: 14.56,
                    fontFamily: "Arial, sans-serif",
                },
            ]);
            tags_ = [];
        }

        console.log(widget);
    };

    const image_add = async (e) => {
        e.preventDefault();

        var x = Math.floor(Math.random() * 420);
        var y = Math.floor(Math.random() * 420);

        const selected_image = e.target.parentElement.id;
        await setImage([
            ...image,
            { id: selected_image, x: x, y: y, w: 285, h: 320 },
        ]);
    };

    const add_main_title = (e) => {
        Set_Main_title(e.target.value);
    };
    const add_main_title2 = (e) => {
        Set_Main_title2(e.target.value);
    };

    const edit_btn_func = (e, text) => {
        text = text.toLowerCase();
        text = text.replace(/ö/g, "o");
        text = text.replace(/ç/g, "c");
        text = text.replace(/ş/g, "s");
        text = text.replace(/ı/g, "i");
        text = text.replace(/ğ/g, "g");
        text = text.replace(/ü/g, "u");
        text = text.replaceAll(" ", "_");
        console.log(text);
        history.push(`/dashboard/${text}/edit`);
    };

    const open_popup = (e) => {
        if (props.profile.company === "") {
            document
                .querySelector(".alert_profile_null")
                .classList.toggle("alert_profile_null_ACTIVE");
            setTimeout(() => {
                document
                    .querySelector(".alert_profile_null")
                    .classList.toggle("alert_profile_null_ACTIVE");
            }, 4000);
        } else {
            const section_all = document.querySelector("section.all_page_management");
            section_all.classList.toggle("section_all_active");
            document.querySelector(".redirect_to_dashboard-btn").style.opacity = "0";
        }
    };
    function close_widget_add2(e) {
        e.preventDefault();
        let all_k_w_t_length = document.querySelectorAll(".gauge_widget_toolbox");
        for (let i = 0; i < all_k_w_t_length.length; i++) {
            document.querySelector(`#k-w-t-${i}`).style.opacity = 0;
            document.querySelector(`#k-w-t-${i}`).style.zIndex = "-100000000000";
        }
        let section = document.querySelector("section.all_page_management");
        if (section.classList.contains("section_dark")) {
            section.classList.remove("section_dark");
        }
        const widgets = document.querySelector(".select_widget_type");
        widgets.classList.toggle("select_widget_type_active");
    }
    function close_widget_add3(e) {
        e.preventDefault();
        Set_btn_widget_control("");

        let all_k_w_t_length = document.querySelectorAll(".gauge_widget_toolbox");
        for (let i = 0; i < all_k_w_t_length.length; i++) {
            document.querySelector(`#k-w-t-${i}`).style.opacity = 0;
            document.querySelector(`#k-w-t-${i}`).style.zIndex = "-100000000000";
        }
        const widgets = document.querySelector(".link_widget");
        widgets.classList.toggle("link_widget_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }
    function close_widget_add5(e, index) {
        e.preventDefault();

        document.querySelector(`#k-w-t-${index}`).style.opacity = 0;
        document.querySelector(`#k-w-t-${index}`).style.zIndex = "-100000000000";

        const widgets = document.querySelector(".trend_widget_toolbox");
        widgets.classList.toggle("trend_widget_toolbox_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }
    function close_widget_add6(e) {
        e.preventDefault();
        let all_k_w_t_length = document.querySelectorAll(".gauge_widget_toolbox");
        for (let i = 0; i < all_k_w_t_length.length; i++) {
            document.querySelector(`#k-w-t-${i}`).style.opacity = 0;
            document.querySelector(`#k-w-t-${i}`).style.zIndex = "-100000000000";
        }
        const widgets = document.querySelector(".input_select_widget");
        widgets.classList.toggle("input_select_widget_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }
    function close_widget_add7(e) {
        e.preventDefault();
        let all_k_w_t_length = document.querySelectorAll(".gauge_widget_toolbox");
        for (let i = 0; i < all_k_w_t_length.length; i++) {
            document.querySelector(`#k-w-t-${i}`).style.opacity = 0;
            document.querySelector(`#k-w-t-${i}`).style.zIndex = "-100000000000";
        }
        const widgets = document.querySelector(".manueL-widget");
        widgets.classList.toggle("manuel_widget_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }
    function close_widget_add4(e) {
        e.preventDefault();
        const widgets = document.querySelector(".gauge_widget");
        widgets.style.opacity = 0;
        widgets.style.zIndex = "-100000000000";

        widgets.classList.toggle("gauge_widget_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }
    function close_widget_add4_4(e, index) {
        e.preventDefault();

        console.log(document.querySelector(`#k-w-t-${index}`));
        document.querySelector(`#k-w-t-${index}`).style.opacity = 0;
        document.querySelector(`#k-w-t-${index}`).style.zIndex = "-100000000000";

        const widgets = document.querySelector(".gauge_widget_toolbox");
        widgets.classList.toggle("gauge_widget_toolbox_active");
    }
    const open_link_widget = () => {
        const widgets_defult = document.querySelector(".link_widget");
        widgets_defult.style.opacity = "1";
        widgets_defult.style.zIndex = "100000000";

        widgets_defult.classList.toggle("link_widget_active");
        const widgets = document.querySelector(".select_widget_type");
        widgets.style.opacity = "0";
    };
    const open_select_widget = () => {
        const widgets_defult = document.querySelector(".input_select_widget");
        widgets_defult.style.opacity = "1";
        widgets_defult.style.zIndex = "100000000";

        widgets_defult.classList.toggle("input_select_widget_active");
        const widgets = document.querySelector(".select_widget_type");
        widgets.style.opacity = "0";
    };
    const open_gauge_widget = () => {
        const widgets_defult = document.querySelector(".gauge_widget");
        console.log(widgets_defult);
        widgets_defult.style.opacity = "1";
        widgets_defult.style.zIndex = "100000000";
        widgets_defult.classList.toggle("gauge_widget_active");
        const widgets = document.querySelector(".select_widget_type");
        widgets.style.opacity = "0";
    };

    const open_trend_widget = () => {
        const widgets_defult = document.querySelector(".trend_widget");
        console.log(widgets_defult);
        widgets_defult.style.opacity = "1";
        widgets_defult.style.zIndex = "100000000";
        widgets_defult.classList.toggle("trend_widget_active");
        const widgets = document.querySelector(".select_widget_type");
        widgets.style.opacity = "0";
    };

    const open_label_widget = () => {
        let popup = document.querySelector(
            ".add_widget_part.create_a_widget.default_widget"
        );
        popup.classList.toggle("add_widget_part_active");
        popup.style.opacity = "1";
        popup.style.zIndex = "100000000";
    };

    const [btn_widget_control, Set_btn_widget_control] = useState("");

    const handleDragStop = (e, data) => {
        let newdata = items3;
        console.log(data);
        newdata.forEach((item) => {
            if (String(item.id) === data.node.id) {
                var a = document.querySelectorAll(".react-draggable");
                console.log(item);
                item.x = data.x;
                item.y = data.y;
            }
        });
        console.log(newdata);
        Set_items3(newdata);
    };

    const save_function = async () => {
        var newdata = items3_3;
        newdata.push({
            items: items3,
            id: Math.floor(items3.length / 2) + widget.length + 41,
            x: Math.floor(Math.random() * 200),
            y: Math.floor(Math.random() * 200),
        });
        Set_items3_3(newdata);

        const section_all2 = document.querySelector("section.toolbox_section");
        section_all2.classList.toggle("toolbox_section_active");
        document.querySelector(".redirect_to_dashboard-btn").style.opacity = "0";
        document.querySelector(".notifications-kapsiyici").style.display = "none";
    };

    const open_toolbox = () => {
        // const section_all2 = document.querySelector("section.toolbox_section_");
        // section_all2.classList.toggle("toolbox_section_active");
        // document.querySelector(".redirect_to_dashboard-btn").style.opacity = "0";
        // document.querySelector(".notifications-kapsiyici").style.display = "none";
    };

    const close_toolbox = () => {
        const section_all = document.querySelector("section.all_page_management");
        section_all.classList.toggle("section_all_active");
        const section_all2 = document.querySelector("section.toolbox_section");
        section_all2.classList.toggle("toolbox_section_active");
        document.querySelector(".redirect_to_dashboard-btn").style.opacity = "1";
        document.querySelector(".notifications-kapsiyici").style.display = "flex";
        document.querySelector(".notifications-kapsiyici").style.justifyContent =
            "center";
    };

    const getGaugeColor = (percent) => {
        if (percent >= 0.7) {
            return "#00FF00"; // Green color for values >= 70%
        } else if (percent >= 0.3) {
            return "#FFFF00"; // Yellow color for values >= 30%
        } else {
            return "#FF0000"; // Red color for values < 30%
        }
    };

    useEffect(() => {
        console.log(items3);
    }, [items3]);

    const delete_item_from_items3 = (e) => {
        let arr = items3.filter((i) => {
            return String(i.id) !== e.target.parentElement.id;
        });

        Set_items3(arr);
    };

    const close_vrf_pop_up = () => {
        document.querySelector(".vrf_detail_popup").classList.toggle("vrf_detail_popup_active")
        Set_popup_state({})
    }

    const [pop_up_id, Set_pop_up_id] = useState(0)


    return (
        <>
            <div className="alert_profile_null">
                You need to specify the company you work for in profile page !
            </div>
            <div className="select_widget_type">
                <i onClick={close_widget_add2} id="qwesa" className="fa fa-times"></i>
                <div onClick={default_widget_click} className="s-w-t">
                    <h3>Standart Widget</h3>
                    <p>Standart labels and texts for simple widgets</p>
                </div>
                <div onClick={open_toolbox} className="s-w-t">
                    <h3>ToolBox</h3>
                    <p>Create a new widget as you wish with a toolbox.</p>
                </div>
                <div onClick={open_gauge_widget} className="s-w-t">
                    <h3>Gauge</h3>
                    <p>Create a new gauge widget to domcdcdk.</p>
                </div>
                <div onClick={open_trend_widget} className="s-w-t">
                    <h3>Trend</h3>
                    <p>Create a trend widget to compare tag data with time.</p>
                </div>
            </div>
            {control === true ? (
                <div
                    style={{
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    className="loading"
                >
                    <img style={{ width: "15%" }} src={loading_} alt="" />
                </div>
            ) : (
                <main className="page_management_main">
                    <section className="toolbox_section_active">
                        <Draggable disabled={true}>
                            <div className="container">

                                <div className="card">
                                    <div
                                        style={{ position: "absolute" }}
                                        className="card-header tool_parts"
                                    >
                                        <div
                                            onClick={(e) => {
                                                if (!e.target.classList.contains("row_active")) {
                                                    let all_rows = document.querySelectorAll(".row");
                                                    all_rows.forEach((item) => {
                                                        item.classList = "row";
                                                    });
                                                    Set_selected_html_tag(e.target.id);
                                                    var newdata = render_items;
                                                    newdata.push("Text");
                                                    Setrender_items(newdata);
                                                    Store.dispatch(set_render_items_toolbox(newdata));
                                                    var newobj = {
                                                        id: newdata.length - 1 + old_items3.length,
                                                        x: 0,
                                                        y: 0,
                                                        type: "text",
                                                        elementDetails: {
                                                            text: "",
                                                        },
                                                    };
                                                    Set_items3((prevArray) => [...prevArray, newobj]);
                                                    e.target.classList.add("row_active");
                                                }
                                            }}
                                            id="text"
                                            className="row"
                                        >
                                            Text
                                        </div>
                                        <div
                                            onClick={(e) => {
                                                open_gauge_widget();
                                                if (!e.target.classList.contains("row_active")) {
                                                    let all_rows = document.querySelectorAll(".row");
                                                    all_rows.forEach((item) => {
                                                        item.classList = "row";
                                                    });
                                                    Set_selected_html_tag(e.target.id);
                                                    var newdata = render_items;
                                                    newdata.push("Gauge");
                                                    Setrender_items(newdata);
                                                    Store.dispatch(set_render_items_toolbox(newdata));

                                                    e.target.classList.add("row_active");
                                                }
                                            }}
                                            id="gauge"
                                            className="row"
                                        >
                                            Gauge
                                        </div>
                                        <div
                                            onClick={(e) => {
                                                if (!e.target.classList.contains("row_active")) {
                                                    let all_rows = document.querySelectorAll(".row");
                                                    all_rows.forEach((item) => {
                                                        item.classList = "row";
                                                    });
                                                    Set_selected_html_tag(e.target.id);
                                                    var newdata = render_items;
                                                    newdata.push("Select");
                                                    Setrender_items(newdata);
                                                    Store.dispatch(set_render_items_toolbox(newdata));
                                                    var newobj = {
                                                        id: newdata.length - 1 + old_items3.length,
                                                        x: 0,
                                                        y: 0,
                                                        type: "select",
                                                        elementDetails: {
                                                            text: "",
                                                        },
                                                    };
                                                    Set_items3((prevArray) => [...prevArray, newobj]);
                                                    e.target.classList.add("row_active");
                                                }
                                            }}
                                            id="select_tag"
                                            className="row"
                                        >
                                            Select
                                        </div>
                                        <div
                                            onClick={(e) => {
                                                if (!e.target.classList.contains("row_active")) {
                                                    let all_rows = document.querySelectorAll(".row");
                                                    all_rows.forEach((item) => {
                                                        item.classList = "row";
                                                    });
                                                    Set_selected_html_tag(e.target.id);
                                                    var newdata = render_items;
                                                    newdata.push("Text_Box");
                                                    Setrender_items(newdata);
                                                    Store.dispatch(set_render_items_toolbox(newdata));
                                                    var newobj = {
                                                        id: newdata.length - 1 + old_items3.length,
                                                        x: 0,
                                                        y: 0,
                                                        type: "text_box",
                                                        elementDetails: {
                                                            text: "",
                                                        },
                                                    };
                                                    Set_items3((prevArray) => [...prevArray, newobj]);
                                                    e.target.classList.add("row_active");
                                                }
                                            }}
                                            id="text_box_page"
                                            className="row"
                                        >
                                            Text Box
                                        </div>
                                        <div
                                            onClick={(e) => {
                                                open_label_widget();
                                                if (!e.target.classList.contains("row_active")) {
                                                    let all_rows = document.querySelectorAll(".row");
                                                    all_rows.forEach((item) => {
                                                        item.classList = "row";
                                                    });
                                                    Set_selected_html_tag(e.target.id);
                                                    var newdata = render_items;
                                                    newdata.push("Label");
                                                    Setrender_items(newdata);
                                                    Store.dispatch(set_render_items_toolbox(newdata));

                                                    e.target.classList.add("row_active");
                                                }
                                            }}
                                            id="label"
                                            className="row"
                                        >
                                            Label
                                        </div>
                                        <div
                                            onClick={(e) => {
                                                if (!e.target.classList.contains("row_active")) {
                                                    let all_rows = document.querySelectorAll(".row");
                                                    all_rows.forEach((item) => {
                                                        item.classList = "row";
                                                    });
                                                    Set_selected_html_tag(e.target.id);
                                                    var newdata = render_items;
                                                    newdata.push("Button");
                                                    Setrender_items(newdata);
                                                    Store.dispatch(set_render_items_toolbox(newdata));
                                                    e.target.classList.add("row_active");
                                                    var newobj = {
                                                        id: newdata.length - 1 + old_items3.length,
                                                        x: 0,
                                                        y: 0,
                                                        type: "button",
                                                        elementDetails: {
                                                            text: "",
                                                        },
                                                    };
                                                    Set_items3((prevArray) => [...prevArray, newobj]);
                                                }
                                            }}
                                            id="button_widget"
                                            className="row"
                                        >
                                            Button-Link Widget
                                        </div>
                                        <button
                                            onClick={(e) => {
                                                console.log(e.target);
                                                document.querySelector(
                                                    "#image_toolbox_input_img"
                                                ).value = "";
                                                document.querySelector(
                                                    "#image_toolbox_input_img"
                                                ).style.display = "block";
                                            }}
                                            className="toolbox_active_input_image row"
                                        >
                                            Image
                                            <input
                                                onChange={(e) => {
                                                    const fileInput = e.target;
                                                    const selectedImage =
                                                        e.target.parentElement.parentElement.parentElement
                                                            .firstElementChild.firstElementChild;
                                                    const uploadButton = e.target.parentElement;
                                                    const file = fileInput.files[0];
                                                    if (file && file.type.startsWith("image/")) {
                                                        const reader = new FileReader();

                                                        reader.onload = function (event) {
                                                            console.log(event.target.result);

                                                            let all_rows = document.querySelectorAll(".row");
                                                            all_rows.forEach((item) => {
                                                                item.classList = "row";
                                                            });
                                                            Set_selected_html_tag(e.target.id);
                                                            var newdata = render_items;
                                                            newdata.push("Button");
                                                            Setrender_items(newdata);
                                                            Store.dispatch(set_render_items_toolbox(newdata));
                                                            e.target.classList.add("row_active");
                                                            console.log(compressData(event.target.result));
                                                            var newobj = {
                                                                id: newdata.length - 1 + old_items3.length,
                                                                x: 0,
                                                                y: 0,
                                                                type: "image",
                                                                elementDetails: {
                                                                    src: event.target.result,
                                                                    src2: compressData(event.target.result),
                                                                },
                                                            };
                                                            Set_items3((prevArray) => [...prevArray, newobj]);
                                                            console.log(newobj);
                                                        };
                                                        reader.readAsDataURL(file);
                                                    } else {
                                                        alert("Lütfen geçerli bir resim dosyası seçin.");
                                                    }
                                                    document.querySelector(
                                                        "#image_toolbox_input_img"
                                                    ).style.display = "none";
                                                }}
                                                type="file"
                                                id="image_toolbox_input_img"
                                            />
                                        </button>

                                        <button
                                            onClick={(e) => {
                                                console.log(e.target);
                                                document.querySelector("#image_toolbox_input").value =
                                                    "";
                                                document.querySelector(
                                                    "#image_toolbox_input"
                                                ).style.display = "block";
                                            }}
                                            className="toolbox_active_input_image row"
                                        >
                                            Background
                                            <input
                                                onChange={(e) => {
                                                    document.querySelector(
                                                        "#image_toolbox_input"
                                                    ).style.display = "block";
                                                    console.log(
                                                        document.querySelector("#image_toolbox_input")
                                                    );

                                                    const fileInput = e.target;
                                                    const uploadButton = e.target.parentElement;
                                                    const file = fileInput.files[0];
                                                    if (file && file.type.startsWith("image/")) {
                                                        const reader = new FileReader();

                                                        reader.onload = function (event) {
                                                            var newdata = render_items;
                                                            newdata.push("Background");
                                                            Setrender_items(newdata);
                                                            Store.dispatch(set_render_items_toolbox(newdata));
                                                            e.target.classList.add("row_active");
                                                            var newobj = {
                                                                id: newdata.length - 1 + old_items3.length,
                                                                x: 0,
                                                                y: 0,
                                                                type: "bg",
                                                                elementDetails: {
                                                                    src: event.target.result,
                                                                },
                                                            };
                                                            Set_items3((prevArray) => [...prevArray, newobj]);
                                                            document.querySelector(
                                                                "section.toolbox_section_active"
                                                            ).style.backgroundImage = `url(${event.target.result})`;

                                                            document.querySelector(
                                                                "section.toolbox_section_active"
                                                            ).style.backgroundPosition = "center 200px";
                                                            document.querySelector(
                                                                "section.toolbox_section_active"
                                                            ).style.backgroundRepeat = "no-repeat";
                                                            document.querySelector(
                                                                "section.toolbox_section_active"
                                                            ).style.backgroundSize = "20%";


                                                            SetBG(event.target.res)
                                                        };

                                                        reader.readAsDataURL(file);
                                                    } else {
                                                        alert("Lütfen geçerli bir resim dosyası seçin.");
                                                    }
                                                    let all_rows = document.querySelectorAll(".row");
                                                    all_rows.forEach((item) => {
                                                        item.classList = "row";
                                                    });
                                                    Set_selected_html_tag(e.target.id);

                                                    document.querySelector(
                                                        "#image_toolbox_input"
                                                    ).style.display = "none";
                                                }}
                                                type="file"
                                                id="image_toolbox_input"
                                            />
                                        </button>

                                        <div
                                            onClick={(e) => {
                                                if (!e.target.classList.contains("row_active")) {
                                                    let all_rows = document.querySelectorAll(".row");
                                                    all_rows.forEach((item) => {
                                                        item.classList = "row";
                                                    });
                                                    Set_selected_html_tag(e.target.id);
                                                    var newdata = render_items;
                                                    newdata.push("Trend");
                                                    Setrender_items(newdata);
                                                    Store.dispatch(set_render_items_toolbox(newdata));
                                                    e.target.classList.add("row_active");
                                                    var newobj = {
                                                        id: newdata.length - 1 + old_items3.length,
                                                        x: 0,
                                                        y: 0,
                                                        type: "trend",
                                                        elementDetails: {
                                                            axis_name: "",
                                                            tagId: null,
                                                            tagName: "",
                                                        },
                                                    };
                                                    Set_items3((prevArray) => [...prevArray, newobj]);
                                                }
                                            }}
                                            id="button_widget"
                                            className="row"
                                        >
                                            Trend Graphic
                                        </div>
                                        <div
                                            onClick={async (e) => {
                                                if (!e.target.classList.contains("row_active")) {

                                                    await Store.dispatch(set_toolbox(items3));

                                                    history.push("/pages_management/white_space/" + page_id);
                                                }
                                            }}
                                            id="button_widget"
                                            className="row"
                                        >
                                            White Space
                                        </div>

                                        <div
                                            onClick={(e) => {
                                                if (!e.target.classList.contains("row_active")) {
                                                    let all_rows = document.querySelectorAll(".row");
                                                    all_rows.forEach((item) => {
                                                        item.classList = "row";
                                                    });
                                                    Set_selected_html_tag(e.target.id);
                                                    var newdata = render_items;
                                                    newdata.push("Title");
                                                    Setrender_items(newdata);
                                                    Store.dispatch(set_render_items_toolbox(newdata));
                                                    e.target.classList.add("row_active");
                                                    var newobj = {
                                                        id: newdata.length - 1 + old_items3.length,
                                                        x: 0,
                                                        y: 0,
                                                        type: "title",
                                                        elementDetails: {
                                                            text: "",
                                                        },
                                                    };
                                                    Set_items3((prevArray) => [...prevArray, newobj]);
                                                }
                                            }}
                                            id="title_widget"
                                            className="row"
                                        >
                                            Title
                                        </div>
                                        <div
                                            onClick={(e) => {

                                                if (!e.target.classList.contains("row_active")) {
                                                    let all_rows = document.querySelectorAll(".row");
                                                    all_rows.forEach((item) => {
                                                        item.classList = "row";
                                                    });
                                                    Set_selected_html_tag(e.target.id);
                                                    var newdata = render_items;
                                                    newdata.push("pop_up_widget");
                                                    let alfb = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
                                                    let say = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5]
                                                    var harf = ""
                                                    var sayı = ""
                                                    var id_guide = ""
                                                    var i = 0;
                                                    while (i < 10) {
                                                        var control_num = Math.floor(Math.random() * 2);
                                                        if (control_num % 2 === 0) {
                                                            harf = alfb[Math.floor(Math.random() * 26)]
                                                            id_guide += harf
                                                        } else {
                                                            sayı = say[Math.floor(Math.random() * 10)]
                                                            id_guide += String(sayı)
                                                        }

                                                        i++
                                                    }

                                                    Store.dispatch(set_temp_id(id_guide))
                                                    Set_temp_id(id_guide)

                                                    console.log(newdata);
                                                    Store.dispatch(set_render_items_toolbox(newdata));
                                                    e.target.classList.add("row_active");
                                                    var newobj = {
                                                        id: id_guide,
                                                        x: 0,
                                                        y: 0,
                                                        type: "pop_up_widget",
                                                        elementDetails: {
                                                            text: "",
                                                            tagId: ""
                                                        },
                                                    };
                                                    Set_items3((prevArray) => [...prevArray, newobj]);
                                                    document.querySelector(".vrf_detail_popup").setAttribute("id", `tag_${String(newdata.length)}`)

                                                    Store.dispatch(set_toolbox([...items3, newobj]));

                                                    document.querySelector(".button2_select_widget").classList.toggle("button2_select_widget_active")
                                                }
                                            }}
                                            id="button_widget"
                                            className="row"
                                        >
                                            Popup
                                        </div>
                                    </div>
                                    {/* <div className="card-body">
                                            <Draggable className="card-body" ref={cardBodyRef}>
                                                
                                            </Draggable>
                                        </div> */}
                                    <div>
                                        {items3 &&
                                            items3.map((item, index) => {
                                                console.log(item);
                                                if (item.type === "pop_up_widget") {
                                                    return (
                                                        <Draggable onStop={handleDragStop}>
                                                            <div id={item.id}>
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>

                                                                <button onClick={() => {
                                                                    Set_pop_up_id(item.id)
                                                                    document.querySelector(".vrf_detail_popup").classList.toggle("vrf_detail_popup_active")
                                                                }} className="btn2_class_">{item.elementDetails.text}</button>

                                                            </div>
                                                        </Draggable>
                                                    )
                                                }
                                                if (item.type === "title") {
                                                    return (
                                                        <Draggable onStop={handleDragStop}>
                                                            <div id={item.id}>
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                <input
                                                                    onChange={(e) => {
                                                                        let data_new = items3;
                                                                        data_new.forEach((i) => {
                                                                            if (
                                                                                String(i.id) ===
                                                                                e.target.parentElement.id
                                                                            ) {
                                                                                i.elementDetails.text = e.target.value;
                                                                            }
                                                                        });
                                                                        Set_items3(data_new);
                                                                    }}
                                                                    type="text"
                                                                    value={
                                                                        item.elementDetails.text !== ""
                                                                            ? item.elementDetails.text
                                                                            : undefined
                                                                    }
                                                                    className="drag-input-title"
                                                                />
                                                            </div>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "text") {
                                                    return (
                                                        <Draggable
                                                            onStop={handleDragStop}
                                                            bounds={
                                                                cardBodyRef.current
                                                                    ? cardBodyRef.current
                                                                    : "body"
                                                            }
                                                        >
                                                            <div id={item.id}>
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                <input
                                                                    onChange={(e) => {
                                                                        let data_new = items3;
                                                                        data_new.forEach((i) => {
                                                                            if (
                                                                                String(i.id) ===
                                                                                e.target.parentElement.id
                                                                            ) {
                                                                                i.elementDetails.text = e.target.value;
                                                                            }
                                                                        });
                                                                        Set_items3(data_new);
                                                                    }}
                                                                    type="text"
                                                                    value={
                                                                        item.elementDetails.text !== ""
                                                                            ? item.elementDetails.text
                                                                            : undefined
                                                                    }
                                                                    className="drag-input-text"
                                                                />
                                                            </div>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "select") {
                                                    console.log(item);
                                                    return (
                                                        <Draggable
                                                            onStop={handleDragStop}
                                                            bounds={
                                                                cardBodyRef.current
                                                                    ? cardBodyRef.current
                                                                    : "body"
                                                            }
                                                        >
                                                            <div id={item.id}>
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                <select
                                                                    style={{ width: "100px" }}
                                                                    onChange={(e) => {
                                                                        var newdata = items3;
                                                                        newdata.forEach((item_) => {
                                                                            console.log(
                                                                                e.target.parentElement,
                                                                                item_
                                                                            );
                                                                            if (
                                                                                String(item_.id) ===
                                                                                String(e.target.parentElement.id)
                                                                            ) {
                                                                                console.log(item_.elementDetails.text);
                                                                                item_.elementDetails.text =
                                                                                    e.target.parentElement.firstElementChild.nextElementSibling.options[
                                                                                        e.target.parentElement.firstElementChild.nextElementSibling.selectedIndex
                                                                                    ].textContent;
                                                                            }
                                                                        });
                                                                        console.log(newdata);
                                                                        Set_items3(newdata);
                                                                    }}
                                                                    name="tag_select"
                                                                    id="tag_select"
                                                                >
                                                                    <option key={"1"} value={"0"}>
                                                                        Select Mode
                                                                    </option>
                                                                    <option value="Start">Start</option>
                                                                    <option value="Stop">Stop</option>
                                                                    <option value="Normal">Normal</option>
                                                                    <option value="BMS">BMS</option>
                                                                    <option value="LOCAL">LOCAL</option>
                                                                    <option value="Alarm">Alarm</option>
                                                                    <option value="ON">ON</option>
                                                                    <option value="OFF">OFF</option>
                                                                    <option value="0">0</option>
                                                                    <option value="1">1</option>
                                                                    <option value="Soğutma">Soğutma</option>
                                                                    <option value="Isıtma">Isıtma</option>
                                                                    <option value="Yukarı">Yukarı</option>
                                                                    <option value="Aşağı">Aşağı</option>
                                                                    <option value="Off">Off</option>
                                                                    <option value="Az">Az</option>
                                                                    <option value="Orta">Orta</option>
                                                                    <option value="Çok">Çok</option>
                                                                </select>
                                                            </div>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "button") {
                                                    return (
                                                        <Draggable
                                                            onStop={handleDragStop}
                                                            bounds={
                                                                cardBodyRef.current
                                                                    ? cardBodyRef.current
                                                                    : "body"
                                                            }
                                                        >
                                                            <select
                                                                onChange={(e) => {
                                                                    var newdata = items3;
                                                                    newdata.forEach((item) => {
                                                                        if (
                                                                            String(item.id) === String(e.target.id)
                                                                        ) {
                                                                            item.elementDetails.text =
                                                                                e.target.options[
                                                                                    e.target.selectedIndex
                                                                                ].textContent;
                                                                        }
                                                                    });
                                                                    console.log(newdata);
                                                                    Set_items3(newdata);
                                                                }}
                                                                id={item.id}
                                                                name="button_link_select"
                                                                className="button_link_select"
                                                            >
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                {pages.map((item) => {
                                                                    return (
                                                                        <option value={index}>
                                                                            {item.pageName}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "gauge") {
                                                    console.log(item);
                                                    var percent = Number(
                                                        Number(
                                                            props.tag_values
                                                                .filter(
                                                                    (x) =>
                                                                        String(x.tagId) ===
                                                                        String(item.elementDetails.tagId)
                                                                )
                                                                .map((x) =>
                                                                    Number(
                                                                        x.tagValue.replaceAll(",", ".")
                                                                    ).toFixed(2)
                                                                )
                                                        ) / Number(item.elementDetails.max_value)
                                                    );
                                                    var değer = props.tag_values
                                                        .filter(
                                                            (x) =>
                                                                String(x.tagId) ===
                                                                String(item.elementDetails.tagId)
                                                        )
                                                        .map((x) =>
                                                            Number(x.tagValue.replaceAll(",", ".")).toFixed(2)
                                                        );
                                                    console.log(percent);
                                                    return (
                                                        <div>
                                                            <Draggable
                                                                onStop={handleDragStop}
                                                                bounds={
                                                                    cardBodyRef.current
                                                                        ? cardBodyRef.current
                                                                        : "body"
                                                                }
                                                            >
                                                                <div className="gauge_widget_tool" id={index}>
                                                                    <div
                                                                        style={{
                                                                            maxWidth: "120px",
                                                                            backgroundColor: "rgb(240,240,240)",
                                                                            border: "2px solid rgb(40,40,40)",
                                                                            padding: "4px 0px",
                                                                        }}
                                                                        className="gauge_widget_tool"
                                                                        id={item.id}
                                                                    >
                                                                        <button
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: "-40%",
                                                                                fontSize: "11px",
                                                                                padding: "4px",
                                                                                zIndex: "100000000000000000000000000",
                                                                            }}
                                                                            onClick={delete_item_from_items3}
                                                                            className="all_2_delete_btn"
                                                                        >
                                                                            Delete
                                                                        </button>
                                                                        <GaugeChart
                                                                            style={{ maxWidth: "120px" }}
                                                                            arcColor={getGaugeColor(percent)}
                                                                            id="gauge-chart"
                                                                            percent={percent}
                                                                            {...gaugeConfig}
                                                                        />
                                                                        <div className="gauge_values_display_page">
                                                                            <span style={{ fontWeight: "600" }}>
                                                                                0
                                                                            </span>
                                                                            <span
                                                                                style={{
                                                                                    fontWeight: "600",
                                                                                    marginLeft: "15px",
                                                                                }}
                                                                            >
                                                                                {değer}
                                                                            </span>
                                                                            <span
                                                                                style={{
                                                                                    fontWeight: "600",
                                                                                    marginRight: "-12px",
                                                                                }}
                                                                            >
                                                                                {item.elementDetails.max_value}
                                                                            </span>
                                                                        </div>
                                                                        <span className="gauge_name_tag">{item.elementDetails.tagName}</span>

                                                                    </div>
                                                                </div>
                                                            </Draggable>
                                                        </div>
                                                    );
                                                }
                                                if (item.type === "trend") {
                                                    var data = [];
                                                    console.log(item);
                                                    var i = 0;
                                                    while (i < 3) {
                                                        tag_values.forEach((j) => {
                                                            if (j.tagId === item.tagId) {
                                                                data.push(item.tagValue);
                                                            }
                                                        });
                                                        i++;
                                                    }

                                                    return (
                                                        <div>
                                                            <div
                                                                id={`k-w-t-${index}`}
                                                                className="trend_widget_toolbox"
                                                            >
                                                                <i
                                                                    onClick={(e) => {
                                                                        close_widget_add5(e, index);
                                                                    }}
                                                                    className="fa fa-times"
                                                                ></i>
                                                                <div className="trend_part">
                                                                    <div className="trend_1">
                                                                        <Line
                                                                            data={chartData}
                                                                            options={chartOptions}
                                                                        />
                                                                    </div>
                                                                    <div className="trend_2">
                                                                        <div className="nokta">
                                                                            <h4>Tag</h4>
                                                                            <select
                                                                                style={{ maxWidth: "180px" }}
                                                                                name="trend_select"
                                                                                id="trend_select_id"
                                                                            >
                                                                                {props.tag_list.map((i, index) => {
                                                                                    return (
                                                                                        <option key={index} value={i.tagId}>
                                                                                            {i.tagName}
                                                                                        </option>
                                                                                    );
                                                                                })}
                                                                            </select>
                                                                        </div>

                                                                        <div className="x-label_axis">
                                                                            <h4>Y-Axis Name:</h4>
                                                                            <input
                                                                                id="cm0-x7x-2-toolbox"
                                                                                type="text"
                                                                                className="y-axis"
                                                                                placeholder="y-axis"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <button
                                                                    onClick={(e) => {
                                                                        var e_2 =
                                                                            document.querySelector(
                                                                                "#trend_select_id"
                                                                            );
                                                                        var toplam = 0;
                                                                        var e_4 =
                                                                            document.querySelector(
                                                                                "#cm0-x7x-2-toolbox"
                                                                            );

                                                                        if (e_4.value !== "") {
                                                                            var newdata = items3;
                                                                            trends_widget.push({
                                                                                tagId:
                                                                                    e_2.options[e_2.selectedIndex].value,
                                                                            });
                                                                            SetTags((prevArray) => [
                                                                                ...prevArray,
                                                                                {
                                                                                    tagId:
                                                                                        e_2.options[e_2.selectedIndex]
                                                                                            .value,
                                                                                },
                                                                            ]);
                                                                            tags_.push(
                                                                                e_2.options[e_2.selectedIndex].value
                                                                            );
                                                                            newdata.forEach((i) => {
                                                                                if (
                                                                                    String(i.id) ===
                                                                                    document.querySelector(
                                                                                        "#widget_ucreated_trend_toolbox"
                                                                                    ).parentElement.id
                                                                                ) {
                                                                                    i.elementDetails.tagName =
                                                                                        e_2.options[
                                                                                            e_2.selectedIndex
                                                                                        ].textContent;
                                                                                    i.elementDetails.tagId =
                                                                                        e_2.options[
                                                                                            e_2.selectedIndex
                                                                                        ].value;
                                                                                    i.elementDetails.axis_name =
                                                                                        e_4.value;
                                                                                }
                                                                            });
                                                                            Set_items3(newdata);
                                                                        } else {
                                                                            alert("Değerleri eksiksiz girin!");
                                                                        }

                                                                        widget_add(e);
                                                                    }}
                                                                    className="btn_olustur_add_widget"
                                                                >
                                                                    Create
                                                                </button>
                                                            </div>
                                                            <Draggable
                                                                onStop={handleDragStop}
                                                                bounds={
                                                                    cardBodyRef.current
                                                                        ? cardBodyRef.current
                                                                        : "body"
                                                                }
                                                            >
                                                                <div
                                                                    id={item.id}
                                                                    onClick={() => {
                                                                        const widgets_defult =
                                                                            document.querySelector(
                                                                                ".trend_widget_toolbox"
                                                                            );
                                                                        console.log(widgets_defult);
                                                                        widgets_defult.style.opacity = "1";
                                                                        widgets_defult.style.zIndex = "100000000";
                                                                        widgets_defult.classList.toggle(
                                                                            "trend_widget_toolbox_active"
                                                                        );
                                                                    }}
                                                                >
                                                                    <button
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "-10%",
                                                                            fontSize: "11px",
                                                                            padding: "4px",
                                                                            zIndex: "100000000000000000000000000",
                                                                        }}
                                                                        onClick={delete_item_from_items3}
                                                                        className="all_2_delete_btn"
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                    <div
                                                                        className="widget_ucreated"
                                                                        id="widget_ucreated_trend_toolbox"
                                                                    >
                                                                        <div>
                                                                            <div>
                                                                                <LineChart
                                                                                    yAxisName={"Deneme"}
                                                                                    data={[1, 2, 3]}
                                                                                    labels={[1, 2, 3]}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Draggable>
                                                        </div>
                                                    );
                                                }
                                                if (item.type === "image") {
                                                    return (
                                                        <div>
                                                            <Draggable onStop={handleDragStop}>
                                                                <div id={item.id}>
                                                                    <button
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "-20%",
                                                                            fontSize: "11px",
                                                                            padding: "4px",
                                                                            zIndex: "100000000000000000000000000",
                                                                        }}
                                                                        onClick={delete_item_from_items3}
                                                                        className="all_2_delete_btn"
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                    <img
                                                                        className="selectedImage_toolbox"
                                                                        src={item.elementDetails.src}
                                                                        alt="Seçilen Resim"
                                                                        style={{
                                                                            display: "block",
                                                                            width: "120px",
                                                                            height: "120px",
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Draggable>
                                                        </div>
                                                    );
                                                }
                                                if (item.type === "label") {
                                                    var değer =
                                                        tag_values &&
                                                        tag_values
                                                            .filter(
                                                                (x) => String(x.tagId) === String(item.tagId)
                                                            )
                                                            .map((a) => a.tagValue);
                                                    değer = değer[0].replaceAll(",", ".");
                                                    değer = Number(değer).toFixed(2);

                                                    var max = Number(item.max);
                                                    var min = Number(item.min);

                                                    var percent = ((değer - min) / (max - min)) * 100;
                                                    return (
                                                        <Draggable onStop={handleDragStop}>
                                                            <div id={item.id} className="main_label">
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                {item.main_title !== "" ? (
                                                                    <h5
                                                                        style={{ margin: "3px 0" }}
                                                                        className="main_titile_label_widget"
                                                                    >
                                                                        {item.main_title}
                                                                    </h5>
                                                                ) : (
                                                                    ""
                                                                )}
                                                                <span>
                                                                    {item.text}{" "}
                                                                    {item.led === "true" ? (
                                                                        <input
                                                                            className="led_checkbox"
                                                                            type="checkbox"
                                                                        />
                                                                    ) : (
                                                                        <input
                                                                            className="led_checkbox"
                                                                            type="checkbox"
                                                                            style={{ backgroundColor: "red" }}
                                                                        />
                                                                    )}
                                                                </span>
                                                                <div
                                                                    style={{ height: "auto" }}
                                                                    className="proggress_bar_default"
                                                                >
                                                                    <div
                                                                        title={`Değer: ${değer}`}
                                                                        style={{
                                                                            textAlign: "center",
                                                                            color: "white",
                                                                            padding: "8px 0",
                                                                            fontWeight: "600",
                                                                            height: "100%",
                                                                            fontSize: "11px",
                                                                            backgroundColor: "red",
                                                                            width: `${percent}%`,
                                                                            borderRadius: "8px",
                                                                            maxWidth: "100%",
                                                                        }}
                                                                    >
                                                                        {değer}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "text_box") {
                                                    return (
                                                        <Draggable
                                                            onStop={handleDragStop}
                                                            bounds={
                                                                cardBodyRef.current
                                                                    ? cardBodyRef.current
                                                                    : "body"
                                                            }
                                                        >
                                                            <div>
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                <span id={item.id} className="w_text_box_span">
                                                                    <input
                                                                        onChange={(e) => {
                                                                            let span = e.target.parentElement;
                                                                            var newdata = items3;
                                                                            newdata.forEach((i) => {
                                                                                if (String(i.id) === String(span.id)) {
                                                                                    i.elementDetails.text = e.target.value;
                                                                                }
                                                                            });
                                                                            Set_items3(newdata);
                                                                        }}
                                                                        value={
                                                                            item.elementDetails.text !== ""
                                                                                ? item.elementDetails.text
                                                                                : undefined
                                                                        }
                                                                        className="w_text_box_inp"
                                                                    />
                                                                </span>
                                                            </div>
                                                        </Draggable>
                                                    );
                                                }
                                            })}
                                    </div>
                                    <div>
                                        {old_items3 &&
                                            old_items3.map((item, index) => {
                                                console.log(item);
                                                if (item.type === "pop_up_widget") {
                                                    return (
                                                        <Draggable onStop={handleDragStop}>
                                                            <div id={item.id}>
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>

                                                                <button onClick={() => {
                                                                    Set_pop_up_id(item.id)
                                                                    document.querySelector(".vrf_detail_popup").classList.toggle("vrf_detail_popup_active")
                                                                }} className="btn2_class_">{item.elementDetails.text}</button>

                                                            </div>
                                                        </Draggable>
                                                    )
                                                }

                                                if (item.type === "title") {
                                                    return (
                                                        <Draggable onStop={handleDragStop}>
                                                            <div id={item.id}>
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                <input
                                                                    onChange={(e) => {
                                                                        let data_new = items3;
                                                                        data_new.forEach((i) => {
                                                                            if (
                                                                                String(i.id) ===
                                                                                e.target.parentElement.id
                                                                            ) {
                                                                                i.title_widget = e.target.value;
                                                                            }
                                                                        });
                                                                        Set_items3(data_new);
                                                                    }}
                                                                    type="text"
                                                                    value={
                                                                        item.title_widget !== ""
                                                                            ? item.title_widget
                                                                            : undefined
                                                                    }
                                                                    className="drag-input-title"
                                                                />
                                                            </div>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "text") {
                                                    return (
                                                        <Draggable
                                                            onStop={handleDragStop}
                                                            bounds={
                                                                cardBodyRef.current
                                                                    ? cardBodyRef.current
                                                                    : "body"
                                                            }
                                                        >
                                                            <div id={item.id}>
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    onChange={(e) => {
                                                                        e.target.value = item.title_widget
                                                                    }}
                                                                    value={
                                                                        item.title_widget !== ""
                                                                            ? item.title_widget
                                                                            : undefined
                                                                    }
                                                                    className="drag-input-text"
                                                                />
                                                            </div>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "select") {
                                                    console.log(item);
                                                    return (
                                                        <Draggable
                                                            onStop={handleDragStop}
                                                            bounds={
                                                                cardBodyRef.current
                                                                    ? cardBodyRef.current
                                                                    : "body"
                                                            }
                                                        >
                                                            <div id={item.id}>
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                <select
                                                                    style={{ width: "100px" }}
                                                                    onChange={(e) => {
                                                                        var newdata = items3;
                                                                        newdata.forEach((item_) => {
                                                                            console.log(
                                                                                e.target.parentElement,
                                                                                item_
                                                                            );
                                                                            if (
                                                                                String(item_.id) ===
                                                                                String(e.target.parentElement.id)
                                                                            ) {
                                                                                console.log(item_);
                                                                                item_.text =
                                                                                    e.target.parentElement.firstElementChild.nextElementSibling.options[
                                                                                        e.target.parentElement.firstElementChild.nextElementSibling.selectedIndex
                                                                                    ].textContent;
                                                                            }
                                                                        });
                                                                        console.log(newdata);
                                                                        Set_items3(newdata);
                                                                    }}
                                                                    name="tag_select"
                                                                    id="tag_select"
                                                                >
                                                                    <option key={"1"} value={"0"}>
                                                                        {item.tagName}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "button") {
                                                    return (
                                                        <Draggable
                                                            onStop={handleDragStop}
                                                            bounds={
                                                                cardBodyRef.current
                                                                    ? cardBodyRef.current
                                                                    : "body"
                                                            }
                                                        >
                                                            <select
                                                                onChange={(e) => {
                                                                    var newdata = items3;
                                                                    newdata.forEach((item) => {
                                                                        if (
                                                                            String(item.id) === String(e.target.id)
                                                                        ) {
                                                                            item.text =
                                                                                e.target.options[
                                                                                    e.target.selectedIndex
                                                                                ].textContent;
                                                                        }
                                                                    });
                                                                    console.log(newdata);
                                                                    Set_items3(newdata);
                                                                }}
                                                                id={item.id}
                                                                name="button_link_select"
                                                                className="button_link_select"
                                                            >
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-100%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                {pages.map((item) => {
                                                                    return (
                                                                        <option value={index}>
                                                                            {item.pageName}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "tag") {
                                                    return (
                                                        <Draggable onStop={handleDragStop}>
                                                            <div id={item.id}>
                                                                <button style={{ position: "absolute", top: "-40%", fontSize: "11px", padding: "4px", zIndex: "100000000000000000000000000" }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                <div className={`tag_${item.id}`} id={item.id}>
                                                                    <div className="tag_ws3_flex_column">
                                                                        <p style={{ fontWeight: "700" }}>{item.elementDetails.text}</p>
                                                                        <p className='p_tag_value_TAG'>{değer}</p>

                                                                    </div>
                                                                </div></div>

                                                        </Draggable>
                                                    )
                                                }
                                                if (item.type === "gauge") {
                                                    console.log(item);
                                                    var percent = Number(
                                                        Number(
                                                            props.tag_values
                                                                .filter(
                                                                    (x) =>
                                                                        String(x.tagId) ===
                                                                        String(item.tagId)
                                                                )
                                                                .map((x) =>
                                                                    Number(
                                                                        x.tagValue.replaceAll(",", ".")
                                                                    ).toFixed(2)
                                                                )
                                                        ) / Number(item.max_value)
                                                    );
                                                    var değer = props.tag_values
                                                        .filter(
                                                            (x) =>
                                                                String(x.tagId) ===
                                                                String(item.tagId)
                                                        )
                                                        .map((x) =>
                                                            Number(x.tagValue.replaceAll(",", ".")).toFixed(2)
                                                        );
                                                    console.log(percent);
                                                    return (
                                                        <div>
                                                            <Draggable
                                                                onStop={handleDragStop}
                                                                bounds={
                                                                    cardBodyRef.current
                                                                        ? cardBodyRef.current
                                                                        : "body"
                                                                }
                                                            >
                                                                <div className="gauge_widget_tool" id={index}>
                                                                    <div
                                                                        style={{
                                                                            maxWidth: "120px",
                                                                            backgroundColor: "rgb(240,240,240)",
                                                                            border: "2px solid rgb(40,40,40)",
                                                                            padding: "4px 0px",
                                                                        }}
                                                                        className="gauge_widget_tool"
                                                                        id={item.id}
                                                                    >
                                                                        <button
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: "-40%",
                                                                                fontSize: "11px",
                                                                                padding: "4px",
                                                                                zIndex: "100000000000000000000000000",
                                                                            }}
                                                                            onClick={delete_item_from_items3}
                                                                            className="all_2_delete_btn"
                                                                        >
                                                                            Delete
                                                                        </button>
                                                                        <GaugeChart
                                                                            style={{ maxWidth: "120px" }}
                                                                            arcColor={getGaugeColor(percent)}
                                                                            id="gauge-chart"
                                                                            percent={percent}
                                                                            {...gaugeConfig}
                                                                        />
                                                                        <div className="gauge_values_display_page">
                                                                            <span style={{ fontWeight: "600" }}>
                                                                                0
                                                                            </span>
                                                                            <span
                                                                                style={{
                                                                                    fontWeight: "600",
                                                                                    marginLeft: "15px",
                                                                                }}
                                                                            >
                                                                                {değer}
                                                                            </span>
                                                                            <span
                                                                                style={{
                                                                                    fontWeight: "600",
                                                                                    marginRight: "-12px",
                                                                                }}
                                                                            >
                                                                                {item.max_value}
                                                                            </span>
                                                                        </div>
                                                                        <span className="gauge_name_tag">{item.elementDetails.tagName}</span>

                                                                    </div>
                                                                </div>
                                                            </Draggable>
                                                        </div>
                                                    );
                                                }
                                                if (item.type === "trend") {
                                                    var data = [];
                                                    console.log(item);
                                                    var i = 0;
                                                    while (i < 3) {
                                                        tag_values.forEach((j) => {
                                                            if (j.tagId === item.tagId) {
                                                                data.push(item.tagValue);
                                                            }
                                                        });
                                                        i++;
                                                    }

                                                    return (
                                                        <div>
                                                            <div
                                                                id={`k-w-t-${index}`}
                                                                className="trend_widget_toolbox"
                                                            >
                                                                <i
                                                                    onClick={(e) => {
                                                                        close_widget_add5(e, index);
                                                                    }}
                                                                    className="fa fa-times"
                                                                ></i>
                                                                <div className="trend_part">
                                                                    <div className="trend_1">
                                                                        <Line
                                                                            data={chartData}
                                                                            options={chartOptions}
                                                                        />
                                                                    </div>
                                                                    <div className="trend_2">
                                                                        <div className="nokta">
                                                                            <h4>Tag</h4>
                                                                            <select
                                                                                style={{ maxWidth: "180px" }}
                                                                                name="trend_select"
                                                                                id="trend_select_id"
                                                                            >
                                                                                {props.tag_list.map((i, index) => {
                                                                                    return (
                                                                                        <option key={index} value={i.tagId}>
                                                                                            {i.tagName}
                                                                                        </option>
                                                                                    );
                                                                                })}
                                                                            </select>
                                                                        </div>

                                                                        <div className="x-label_axis">
                                                                            <h4>Y-Axis Name:</h4>
                                                                            <input
                                                                                id="cm0-x7x-2-toolbox"
                                                                                type="text"
                                                                                className="y-axis"
                                                                                placeholder="y-axis"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <button
                                                                    onClick={(e) => {
                                                                        var e_2 =
                                                                            document.querySelector(
                                                                                "#trend_select_id"
                                                                            );
                                                                        var toplam = 0;
                                                                        var e_4 =
                                                                            document.querySelector(
                                                                                "#cm0-x7x-2-toolbox"
                                                                            );

                                                                        if (e_4.value !== "") {
                                                                            var newdata = items3;
                                                                            trends_widget.push({
                                                                                tagId:
                                                                                    e_2.options[e_2.selectedIndex].value,
                                                                            });
                                                                            SetTags((prevArray) => [
                                                                                ...prevArray,
                                                                                {
                                                                                    tagId:
                                                                                        e_2.options[e_2.selectedIndex]
                                                                                            .value,
                                                                                },
                                                                            ]);
                                                                            tags_.push(
                                                                                e_2.options[e_2.selectedIndex].value
                                                                            );
                                                                            newdata.forEach((i) => {
                                                                                if (
                                                                                    String(i.id) ===
                                                                                    document.querySelector(
                                                                                        "#widget_ucreated_trend_toolbox"
                                                                                    ).parentElement.id
                                                                                ) {
                                                                                    i.elementDetails.tagName =
                                                                                        e_2.options[
                                                                                            e_2.selectedIndex
                                                                                        ].textContent;
                                                                                    i.elementDetails.tagId =
                                                                                        e_2.options[
                                                                                            e_2.selectedIndex
                                                                                        ].value;
                                                                                    i.elementDetails.axis_name =
                                                                                        e_4.value;
                                                                                }
                                                                            });
                                                                            Set_items3(newdata);
                                                                        } else {
                                                                            alert("Değerleri eksiksiz girin!");
                                                                        }

                                                                        widget_add(e);
                                                                    }}
                                                                    className="btn_olustur_add_widget"
                                                                >
                                                                    Create
                                                                </button>
                                                            </div>
                                                            <Draggable
                                                                onStop={handleDragStop}
                                                                bounds={
                                                                    cardBodyRef.current
                                                                        ? cardBodyRef.current
                                                                        : "body"
                                                                }
                                                            >
                                                                <div
                                                                    id={item.id}
                                                                    onClick={() => {
                                                                        const widgets_defult =
                                                                            document.querySelector(
                                                                                ".trend_widget_toolbox"
                                                                            );
                                                                        console.log(widgets_defult);
                                                                        widgets_defult.style.opacity = "1";
                                                                        widgets_defult.style.zIndex = "100000000";
                                                                        widgets_defult.classList.toggle(
                                                                            "trend_widget_toolbox_active"
                                                                        );
                                                                    }}
                                                                >
                                                                    <button
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "-10%",
                                                                            fontSize: "11px",
                                                                            padding: "4px",
                                                                            zIndex: "100000000000000000000000000",
                                                                        }}
                                                                        onClick={delete_item_from_items3}
                                                                        className="all_2_delete_btn"
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                    <div
                                                                        className="widget_ucreated"
                                                                        id="widget_ucreated_trend_toolbox"
                                                                    >
                                                                        <div>
                                                                            <div>
                                                                                <LineChart
                                                                                    yAxisName={"Deneme"}
                                                                                    data={[1, 2, 3]}
                                                                                    labels={[1, 2, 3]}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Draggable>
                                                        </div>
                                                    );
                                                }
                                                if (item.type === "label") {
                                                    var değer =
                                                        tag_values &&
                                                        tag_values
                                                            .filter(
                                                                (x) => String(x.tagId) === String(item.tagId)
                                                            )
                                                            .map((a) => a.tagValue);
                                                    değer = değer[0].replaceAll(",", ".");
                                                    değer = Number(değer).toFixed(2);

                                                    var max = Number(item.max);
                                                    var min = Number(item.min);

                                                    var percent = ((değer - min) / (max - min)) * 100;
                                                    return (
                                                        <Draggable onStop={handleDragStop}>
                                                            <div id={item.id} className="main_label">
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-20%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                {item.main_title !== "" ? (
                                                                    <h5
                                                                        style={{ margin: "3px 0" }}
                                                                        className="main_titile_label_widget"
                                                                    >
                                                                        {item.main_title}
                                                                    </h5>
                                                                ) : (
                                                                    ""
                                                                )}
                                                                <span>
                                                                    {item.text}{" "}
                                                                    {item.led === "true" ? (
                                                                        <input
                                                                            className="led_checkbox"
                                                                            type="checkbox"
                                                                        />
                                                                    ) : (
                                                                        <input
                                                                            className="led_checkbox"
                                                                            type="checkbox"
                                                                            style={{ backgroundColor: "red" }}
                                                                        />
                                                                    )}
                                                                </span>
                                                                <div
                                                                    style={{ height: "auto" }}
                                                                    className="proggress_bar_default"
                                                                >
                                                                    <div
                                                                        title={`Değer: ${değer}`}
                                                                        style={{
                                                                            textAlign: "center",
                                                                            color: "white",
                                                                            padding: "8px 0",
                                                                            fontWeight: "600",
                                                                            height: "100%",
                                                                            fontSize: "11px",
                                                                            backgroundColor: "red",
                                                                            width: `${percent}%`,
                                                                            borderRadius: "8px",
                                                                            maxWidth: "100%",
                                                                        }}
                                                                    >
                                                                        {değer}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "text_box") {
                                                    return (
                                                        <Draggable
                                                            onStop={handleDragStop}
                                                            bounds={
                                                                cardBodyRef.current
                                                                    ? cardBodyRef.current
                                                                    : "body"
                                                            }
                                                        >
                                                            <div>
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-10%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                <span id={item.id} className="w_text_box_span">
                                                                    <input
                                                                        onChange={(e) => {
                                                                            let span = e.target.parentElement;
                                                                            var newdata = items3;
                                                                            newdata.forEach((i) => {
                                                                                if (String(i.id) === String(span.id)) {
                                                                                    i.elementDetails.text = e.target.value;
                                                                                }
                                                                            });
                                                                            Set_items3(newdata);
                                                                        }}
                                                                        value={
                                                                            item.elementDetails.text !== ""
                                                                                ? item.elementDetails.text
                                                                                : undefined
                                                                        }
                                                                        className="w_text_box_inp"
                                                                    />
                                                                </span>
                                                            </div>
                                                        </Draggable>
                                                    );
                                                }
                                                if (item.type === "white_spaces") {
                                                    return (
                                                        <Draggable onStop={handleDragStop}>
                                                            <div className="card-body_white_paper white_space">
                                                                <div id={item.id} className="white_paper_xs">
                                                                    <button
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "-6%",
                                                                            fontSize: "11px",
                                                                            padding: "4px",
                                                                            zIndex: "100000000000000000000000000",
                                                                        }}
                                                                        onClick={delete_item_from_items3}
                                                                        className="all_2_delete_btn"
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                    <div>
                                                                        {item.elementDetails.map((item, index) => {
                                                                            console.log(item);
                                                                            if (item.type === "text") {
                                                                                return (
                                                                                    <Draggable
                                                                                        position={{ x: item.x, y: item.y }}
                                                                                        disabled={true}
                                                                                    >
                                                                                        <div id={item.id}>
                                                                                            <input
                                                                                                style={{
                                                                                                    backgroundColor: "white",
                                                                                                    width: "40%",
                                                                                                }}
                                                                                                type="text"
                                                                                                className="drag-input-text"
                                                                                                value={item.elementDetails.text}
                                                                                            />
                                                                                        </div>
                                                                                    </Draggable>
                                                                                );
                                                                            }
                                                                            if (item.type === "title") {
                                                                                console.log(item);
                                                                                return (
                                                                                    <Draggable
                                                                                        disabled={true}
                                                                                        position={{ x: item.x, y: item.y }}
                                                                                    >
                                                                                        <div id={item.id}>
                                                                                            <input
                                                                                                style={{
                                                                                                    backgroundColor: "white",
                                                                                                }}
                                                                                                onChange={(e) => {
                                                                                                    let data_new = items3;
                                                                                                    data_new.forEach((i) => {
                                                                                                        if (
                                                                                                            String(i.id) ===
                                                                                                            e.target.parentElement.id
                                                                                                        ) {
                                                                                                            i.elementDetails.text =
                                                                                                                e.target.value;
                                                                                                        }
                                                                                                    });
                                                                                                    Set_items3(data_new);
                                                                                                }}
                                                                                                type="text"
                                                                                                value={
                                                                                                    item.elementDetails.text !==
                                                                                                        ""
                                                                                                        ? item.elementDetails.text
                                                                                                        : undefined
                                                                                                }
                                                                                                className="drag-input-title"
                                                                                            />
                                                                                        </div>
                                                                                    </Draggable>
                                                                                );
                                                                            }
                                                                            if (item.type === "label") {
                                                                                return (
                                                                                    <Draggable
                                                                                        position={{ x: item.x, y: item.y }}
                                                                                        disabled={true}
                                                                                    >
                                                                                        <div
                                                                                            id={item.id}
                                                                                            className="main_label"
                                                                                        >
                                                                                            {item.main_title !== "" ? (
                                                                                                <h5
                                                                                                    style={{
                                                                                                        display: "block",
                                                                                                        height: "20px",
                                                                                                        margin: "0",
                                                                                                    }}
                                                                                                    className="main_titile_label_widget"
                                                                                                >
                                                                                                    {item.main_title}
                                                                                                </h5>
                                                                                            ) : (
                                                                                                ""
                                                                                            )}
                                                                                            <span>
                                                                                                {item.text}{" "}
                                                                                                {item.led === "true" ? (
                                                                                                    <input
                                                                                                        className="led_checkbox"
                                                                                                        type="checkbox"
                                                                                                    />
                                                                                                ) : (
                                                                                                    <input
                                                                                                        className="led_checkbox"
                                                                                                        type="checkbox"
                                                                                                        style={{
                                                                                                            backgroundColor: "red",
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </span>
                                                                                            <div
                                                                                                style={{ height: "auto" }}
                                                                                                className="proggress_bar_default"
                                                                                            >
                                                                                                <div
                                                                                                    title={`Değer: 100`}
                                                                                                    style={{
                                                                                                        textAlign: "center",
                                                                                                        color: "white",
                                                                                                        padding: "8px 0",
                                                                                                        fontWeight: "600",
                                                                                                        height: "100%",
                                                                                                        fontSize: "11px",
                                                                                                        backgroundColor: "red",
                                                                                                        width: `60%`,
                                                                                                        borderRadius: "8px",
                                                                                                    }}
                                                                                                >
                                                                                                    100
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Draggable>
                                                                                );
                                                                            }
                                                                            if (item.type === "led") {
                                                                                let color = "green";
                                                                                if (item.elementDetails.color) {
                                                                                    color = item.elementDetails.color;
                                                                                }
                                                                                return (
                                                                                    <Draggable
                                                                                        position={{ x: item.x, y: item.y }}
                                                                                        disabled={true}
                                                                                    >
                                                                                        <div id={item.id}>
                                                                                            <input
                                                                                                style={{
                                                                                                    backgroundColor: color,
                                                                                                }}
                                                                                                type="checkbox"
                                                                                                id="white_space_led"
                                                                                            />
                                                                                        </div>
                                                                                    </Draggable>
                                                                                );
                                                                            }
                                                                            if (item.type === "gauge") {
                                                                                var percent = Number(
                                                                                    Number(
                                                                                        props.tag_values
                                                                                            .filter(
                                                                                                (x) =>
                                                                                                    String(x.tagId) ===
                                                                                                    String(item.elementDetails.id)
                                                                                            )
                                                                                            .map((x) =>
                                                                                                Number(
                                                                                                    x.tagValue.replaceAll(
                                                                                                        ",",
                                                                                                        "."
                                                                                                    )
                                                                                                ).toFixed(2)
                                                                                            )
                                                                                    ) /
                                                                                    Number(
                                                                                        item.elementDetails.max_value
                                                                                    )
                                                                                );
                                                                                var değer = props.tag_values
                                                                                    .filter(
                                                                                        (x) =>
                                                                                            String(x.tagId) ===
                                                                                            String(item.elementDetails.id)
                                                                                    )
                                                                                    .map((x) =>
                                                                                        Number(
                                                                                            x.tagValue.replaceAll(",", ".")
                                                                                        ).toFixed(2)
                                                                                    );
                                                                                return (
                                                                                    <div>
                                                                                        <Draggable
                                                                                            disabled={true}
                                                                                            position={{
                                                                                                x: item.x,
                                                                                                y: item.y,
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                className="gauge_widget_tool"
                                                                                                id={index}
                                                                                            >
                                                                                                <div
                                                                                                    style={{
                                                                                                        maxWidth: "100px",
                                                                                                        backgroundColor:
                                                                                                            "rgb(240,240,240)",
                                                                                                        border:
                                                                                                            "2px solid rgb(40,40,40)",
                                                                                                        padding: "4px 0px",
                                                                                                    }}
                                                                                                    className="gauge_widget_tool"
                                                                                                    id={index}
                                                                                                >
                                                                                                    <GaugeChart
                                                                                                        style={{
                                                                                                            maxWidth: "100px",
                                                                                                        }}
                                                                                                        arcColor={getGaugeColor(
                                                                                                            percent
                                                                                                        )}
                                                                                                        id="gauge-chart"
                                                                                                        percent={percent}
                                                                                                        {...gaugeConfig}
                                                                                                    />
                                                                                                    <div className="gauge_values_display_page_toolbox">
                                                                                                        <span>0</span>
                                                                                                        <span>{değer}</span>
                                                                                                        <span>
                                                                                                            {
                                                                                                                item.elementDetails
                                                                                                                    .max_value
                                                                                                            }
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </Draggable>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            if (item.type === "button") {
                                                                                return (
                                                                                    <Draggable
                                                                                        disabled={true}
                                                                                        position={{ x: item.x, y: item.y }}
                                                                                    >
                                                                                        <select
                                                                                            id={item.id}
                                                                                            name="button_link_select"
                                                                                            className="button_link_select"
                                                                                        >
                                                                                            {props.pages.map((item) => {
                                                                                                return (
                                                                                                    <option value={index}>
                                                                                                        {item.pageName}
                                                                                                    </option>
                                                                                                );
                                                                                            })}
                                                                                        </select>
                                                                                    </Draggable>
                                                                                );
                                                                            }
                                                                            if (item.type === "select") {
                                                                                return (
                                                                                    <Draggable
                                                                                        position={{ x: item.x, y: item.y }}
                                                                                        disabled={true}
                                                                                    >
                                                                                        <div id={item.id}>
                                                                                            <select
                                                                                                name="tag_select"
                                                                                                id="tag_select"
                                                                                            >
                                                                                                <option
                                                                                                    key={"1"}
                                                                                                    value={item.elementDetails.id}
                                                                                                >
                                                                                                    {item.elementDetails.text}
                                                                                                </option>
                                                                                            </select>
                                                                                        </div>
                                                                                    </Draggable>
                                                                                );
                                                                            }
                                                                            if (item.type === "text_box") {
                                                                                return (
                                                                                    <Draggable
                                                                                        disabled={true}
                                                                                        position={{ x: item.x, y: item.y }}
                                                                                    >
                                                                                        <span
                                                                                            id={item.id}
                                                                                            className="w_text_box_span"
                                                                                        >
                                                                                            <input
                                                                                                value={item.elementDetails.text}
                                                                                                disabled={true}
                                                                                                className="w_text_box_inp"
                                                                                            />
                                                                                        </span>
                                                                                    </Draggable>
                                                                                );
                                                                            }
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Draggable>
                                                    )

                                                }
                                            })}
                                    </div>

                                    <div>
                                        {images.map((item, index) => {
                                            return (
                                                <div>
                                                    <Draggable onStop={handleDragStop}>
                                                        <div id={item.id}>
                                                            <button
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "-20%",
                                                                    fontSize: "11px",
                                                                    padding: "4px",
                                                                    zIndex: "100000000000000000000000000",
                                                                }}
                                                                onClick={delete_item_from_items3}
                                                                className="all_2_delete_btn"
                                                            >
                                                                Delete
                                                            </button>
                                                            <img
                                                                className="selectedImage_toolbox"
                                                                src={item.src}
                                                                alt="Seçilen Resim"
                                                                style={{
                                                                    display: "block",
                                                                    width: "120px",
                                                                    height: "120px",
                                                                }}
                                                            />
                                                        </div>
                                                    </Draggable>
                                                </div>

                                            )
                                        })}
                                    </div>

                                    <div>
                                        {props.white_space_ && props.white_space_.length > 0
                                            ? props.white_space_.map((item_, index_) => {
                                                console.log(item_);
                                                return (
                                                    <Draggable onStop={handleDragStop}>
                                                        <div className="card-body_white_paper white_space">
                                                            <div id={item_.id} className="white_paper_xs">
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-6%",
                                                                        fontSize: "11px",
                                                                        padding: "4px",
                                                                        zIndex: "100000000000000000000000000",
                                                                    }}
                                                                    onClick={delete_item_from_items3}
                                                                    className="all_2_delete_btn"
                                                                >
                                                                    Delete
                                                                </button>
                                                                <div>
                                                                    {item_.elementDetails.map((item, index) => {
                                                                        console.log(item);
                                                                        if (item.type === "text") {
                                                                            return (
                                                                                <Draggable
                                                                                    position={{ x: item.x, y: item.y }}
                                                                                    disabled={true}
                                                                                >
                                                                                    <div id={item.id}>
                                                                                        <input
                                                                                            style={{
                                                                                                backgroundColor: "white",
                                                                                                width: "40%",
                                                                                            }}
                                                                                            type="text"
                                                                                            className="drag-input-text"
                                                                                            value={item.elementDetails.text}
                                                                                        />
                                                                                    </div>
                                                                                </Draggable>
                                                                            );
                                                                        }
                                                                        if (item.type === "title") {
                                                                            console.log(item);
                                                                            return (
                                                                                <Draggable
                                                                                    disabled={true}
                                                                                    position={{ x: item.x, y: item.y }}
                                                                                >
                                                                                    <div id={item.id}>
                                                                                        <input
                                                                                            style={{
                                                                                                backgroundColor: "white",
                                                                                            }}
                                                                                            onChange={(e) => {
                                                                                                let data_new = items3;
                                                                                                data_new.forEach((i) => {
                                                                                                    if (
                                                                                                        String(i.id) ===
                                                                                                        e.target.parentElement.id
                                                                                                    ) {
                                                                                                        i.elementDetails.text =
                                                                                                            e.target.value;
                                                                                                    }
                                                                                                });
                                                                                                Set_items3(data_new);
                                                                                            }}
                                                                                            type="text"
                                                                                            value={
                                                                                                item.elementDetails.text !==
                                                                                                    ""
                                                                                                    ? item.elementDetails.text
                                                                                                    : undefined
                                                                                            }
                                                                                            className="drag-input-title"
                                                                                        />
                                                                                    </div>
                                                                                </Draggable>
                                                                            );
                                                                        }
                                                                        if (item.type === "label") {
                                                                            return (
                                                                                <Draggable
                                                                                    position={{ x: item.x, y: item.y }}
                                                                                    disabled={true}
                                                                                >
                                                                                    <div
                                                                                        id={item.id}
                                                                                        className="main_label"
                                                                                    >
                                                                                        {item.main_title !== "" ? (
                                                                                            <h5
                                                                                                style={{
                                                                                                    display: "block",
                                                                                                    height: "20px",
                                                                                                    margin: "0",
                                                                                                }}
                                                                                                className="main_titile_label_widget"
                                                                                            >
                                                                                                {item.main_title}
                                                                                            </h5>
                                                                                        ) : (
                                                                                            ""
                                                                                        )}
                                                                                        <span>
                                                                                            {item.text}{" "}
                                                                                            {item.led === "true" ? (
                                                                                                <input
                                                                                                    className="led_checkbox"
                                                                                                    type="checkbox"
                                                                                                />
                                                                                            ) : (
                                                                                                <input
                                                                                                    className="led_checkbox"
                                                                                                    type="checkbox"
                                                                                                    style={{
                                                                                                        backgroundColor: "red",
                                                                                                    }}
                                                                                                />
                                                                                            )}
                                                                                        </span>
                                                                                        <div
                                                                                            style={{ height: "auto" }}
                                                                                            className="proggress_bar_default"
                                                                                        >
                                                                                            <div
                                                                                                title={`Değer: 100`}
                                                                                                style={{
                                                                                                    textAlign: "center",
                                                                                                    color: "white",
                                                                                                    padding: "8px 0",
                                                                                                    fontWeight: "600",
                                                                                                    height: "100%",
                                                                                                    fontSize: "11px",
                                                                                                    backgroundColor: "red",
                                                                                                    width: `60%`,
                                                                                                    borderRadius: "8px",
                                                                                                }}
                                                                                            >
                                                                                                100
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </Draggable>
                                                                            );
                                                                        }
                                                                        if (item.type === "led") {
                                                                            let color = "green";
                                                                            if (item.elementDetails.color) {
                                                                                color = item.elementDetails.color;
                                                                            }
                                                                            return (
                                                                                <Draggable
                                                                                    position={{ x: item.x, y: item.y }}
                                                                                    disabled={true}
                                                                                >
                                                                                    <div id={item.id}>
                                                                                        <input
                                                                                            style={{
                                                                                                backgroundColor: color,
                                                                                            }}
                                                                                            type="checkbox"
                                                                                            id="white_space_led"
                                                                                        />
                                                                                    </div>
                                                                                </Draggable>
                                                                            );
                                                                        }
                                                                        if (item.type === "gauge") {
                                                                            var percent = Number(
                                                                                Number(
                                                                                    props.tag_values
                                                                                        .filter(
                                                                                            (x) =>
                                                                                                String(x.tagId) ===
                                                                                                String(item.elementDetails.id)
                                                                                        )
                                                                                        .map((x) =>
                                                                                            Number(
                                                                                                x.tagValue.replaceAll(
                                                                                                    ",",
                                                                                                    "."
                                                                                                )
                                                                                            ).toFixed(2)
                                                                                        )
                                                                                ) /
                                                                                Number(
                                                                                    item.elementDetails.max_value
                                                                                )
                                                                            );
                                                                            var değer = props.tag_values
                                                                                .filter(
                                                                                    (x) =>
                                                                                        String(x.tagId) ===
                                                                                        String(item.elementDetails.id)
                                                                                )
                                                                                .map((x) =>
                                                                                    Number(
                                                                                        x.tagValue.replaceAll(",", ".")
                                                                                    ).toFixed(2)
                                                                                );
                                                                            return (
                                                                                <div>
                                                                                    <Draggable
                                                                                        disabled={true}
                                                                                        position={{
                                                                                            x: item.x,
                                                                                            y: item.y,
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            className="gauge_widget_tool"
                                                                                            id={index}
                                                                                        >
                                                                                            <div
                                                                                                style={{
                                                                                                    maxWidth: "100px",
                                                                                                    backgroundColor:
                                                                                                        "rgb(240,240,240)",
                                                                                                    border:
                                                                                                        "2px solid rgb(40,40,40)",
                                                                                                    padding: "4px 0px",
                                                                                                }}
                                                                                                className="gauge_widget_tool"
                                                                                                id={index}
                                                                                            >
                                                                                                <GaugeChart
                                                                                                    style={{
                                                                                                        maxWidth: "100px",
                                                                                                    }}
                                                                                                    arcColor={getGaugeColor(
                                                                                                        percent
                                                                                                    )}
                                                                                                    id="gauge-chart"
                                                                                                    percent={percent}
                                                                                                    {...gaugeConfig}
                                                                                                />
                                                                                                <div className="gauge_values_display_page_toolbox">
                                                                                                    <span>0</span>
                                                                                                    <span>{değer}</span>
                                                                                                    <span>
                                                                                                        {
                                                                                                            item.elementDetails
                                                                                                                .max_value
                                                                                                        }
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Draggable>
                                                                                </div>
                                                                            );
                                                                        }
                                                                        if (item.type === "button") {
                                                                            return (
                                                                                <Draggable
                                                                                    disabled={true}
                                                                                    position={{ x: item.x, y: item.y }}
                                                                                >
                                                                                    <select
                                                                                        id={item.id}
                                                                                        name="button_link_select"
                                                                                        className="button_link_select"
                                                                                    >
                                                                                        {props.pages.map((item) => {
                                                                                            return (
                                                                                                <option value={index}>
                                                                                                    {item.pageName}
                                                                                                </option>
                                                                                            );
                                                                                        })}
                                                                                    </select>
                                                                                </Draggable>
                                                                            );
                                                                        }
                                                                        if (item.type === "select") {
                                                                            return (
                                                                                <Draggable
                                                                                    position={{ x: item.x, y: item.y }}
                                                                                    disabled={true}
                                                                                >
                                                                                    <div id={item.id}>
                                                                                        <select
                                                                                            name="tag_select"
                                                                                            id="tag_select"
                                                                                        >
                                                                                            <option
                                                                                                key={"1"}
                                                                                                value={item.elementDetails.id}
                                                                                            >
                                                                                                {item.elementDetails.text}
                                                                                            </option>
                                                                                        </select>
                                                                                    </div>
                                                                                </Draggable>
                                                                            );
                                                                        }
                                                                        if (item.type === "text_box") {
                                                                            return (
                                                                                <Draggable
                                                                                    disabled={true}
                                                                                    position={{ x: item.x, y: item.y }}
                                                                                >
                                                                                    <span
                                                                                        id={item.id}
                                                                                        className="w_text_box_span"
                                                                                    >
                                                                                        <input
                                                                                            value={item.elementDetails.text}
                                                                                            disabled={true}
                                                                                            className="w_text_box_inp"
                                                                                        />
                                                                                    </span>
                                                                                </Draggable>
                                                                            );
                                                                        }
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Draggable>
                                                );
                                            })
                                            : ""}
                                    </div>

                                    <div style={{ marginTop: "103%" }} className="card-footer">
                                        <button onClick={OnFormSubmit} className="save">
                                            Save <i className="fa fa-check"></i>
                                        </button>
                                        <button onClick={close_toolbox} className="cancel">
                                            Cancel <i class="fa-solid fa-ban"></i>
                                        </button>
                                        <input
                                            type="text"
                                            placeholder="page name"
                                            value={page_name}
                                            onChange={(e) => {
                                                console.log(e.target.value);
                                                Set_page_name(e.target.value)
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Draggable>
                    </section>
                    <div className="button2_select_widget" >
                        <div className=" select_part">
                            <div className="row">
                                <span>Button Name:</span>
                                <input id={temp_id} onChange={(e) => {
                                    var newdata = items3;
                                    newdata.forEach((item) => {
                                        if (
                                            String(item.id) === String(e.target.id)
                                        ) {
                                            item.elementDetails.text =
                                                e.target.value
                                        }
                                    });
                                    console.log(newdata);
                                    Set_items3(newdata);
                                }} type="text" className="btn2_name-input" />
                            </div>

                        </div>
                        <button id={items3.length} onClick={(e) => {
                            document.querySelector(".button2_select_widget").classList.toggle("button2_select_widget_active")
                            var newdata = items3;
                            newdata.forEach((item) => {
                                console.log(item);
                                if (
                                    String(item.id) === String(e.target.id)
                                ) {
                                    item.elementDetails.text = e.target.parentElement.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.value

                                }
                            });
                            console.log(newdata);
                            Set_items3(newdata);
                            Set_temp_id("")


                            history.push("/create_pop_up2");

                        }}
                        >Create</button>
                    </div>
                    <div
                        id="k-w-t"
                        className="add_widget_part create_a_widget default_widget"
                    >
                        <i onClick={close_widget_add} className="fa fa-times"></i>
                        <input
                            style={{ color: "rgb(34,34,34)", fontSize: "21px" }}
                            type="text"
                            value={main_title}
                            onChange={add_main_title}
                            placeholder="Main Title (optional)"
                        />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "80%",
                                marginBottom: "-12px",
                            }}
                        >
                            <input
                                id="gdu-3"
                                placeholder="Label"
                                className="top_add_widget add_title"
                            />
                            <select
                                style={{ maxWidth: "180px" }}
                                name="default_widget_value"
                                id="default_widget_value_id"
                            >
                                {props.tag_list.map((i) => {
                                    return <option value={i.tagId}>{i.tagName}</option>;
                                })}
                            </select>
                        </div>
                        <div
                            style={{ width: "80%", fontWeight: "600", fontSize: "18px" }}
                            className="input-group"
                        >
                            Min Value:{" "}
                            <input
                                style={{ fontWeight: "600", fontSize: "16px" }}
                                value={min}
                                onChange={OnChangeMin}
                                type="number"
                                placeholder="min"
                                name=""
                                id="min_default"
                            />
                        </div>
                        <div
                            style={{ width: "80%", fontWeight: "600", fontSize: "18px" }}
                            className="input-group"
                        >
                            Max Value:{" "}
                            <input
                                style={{ fontWeight: "600", fontSize: "18px" }}
                                value={max}
                                onChange={OnChangeMax}
                                type="number"
                                placeholder="max"
                                name=""
                                id="max_default"
                            />
                        </div>
                        <div
                            style={{ width: "80%", fontWeight: "600", fontSize: "18px" }}
                            className="input-group"
                        >
                            Alarm Value
                            <input
                                style={{ fontWeight: "600", fontSize: "18px" }}
                                type="number"
                                placeholder="alarm"
                                name=""
                                id="alarm_default"
                            />
                        </div>
                        <div className="add_ledPart">
                            <button
                                onClick={() => {
                                    led = true;
                                }}
                                className="add_led_btn"
                            >
                                Add LED
                            </button>
                        </div>

                        <button
                            onClick={async (e) => {
                                add_widget_plus(e);
                                widget_add(e);
                            }}
                            className="btn_olustur_add_widget"
                        >
                            Create
                        </button>
                    </div>
                    <div id="k-w-t" className="link_widget">
                        {btn_widget_control === "" ? (
                            <>
                                <i onClick={close_widget_add3} className="fa fa-times"></i>
                                <div
                                    id="link"
                                    onClick={() => {
                                        Set_btn_widget_control("link");
                                    }}
                                    className="box"
                                >
                                    Link Widget
                                </div>
                                <div
                                    onClick={() => {
                                        Set_btn_widget_control("program");
                                    }}
                                    id="program"
                                    className="box"
                                >
                                    Program Widget
                                </div>
                            </>
                        ) : btn_widget_control === "link" ? (
                            <>
                                <div className="choose_page_part">
                                    Choose Page
                                    <select
                                        style={{ maxWidth: "180px" }}
                                        name="page_select"
                                        id="page_select_id"
                                    >
                                        {props.pages_names.map((i, index) => {
                                            return (
                                                <option key={index} value={i}>
                                                    {i}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>

                                <button
                                    onClick={(e) => {
                                        Set_btn_widget_control("");

                                        document.querySelectorAll("#k-w-t").forEach((i) => {
                                            i.style.opacity = "0";
                                            i.style.zIndex = "-1000000000";
                                        });
                                        const widgets = document.querySelector(".link_widget");
                                        widgets.classList.toggle("link_widget_active");
                                        const widgets2 = document.querySelector(
                                            ".select_widget_type"
                                        );
                                        widgets2.style.opacity = "1";
                                        var e_2 = document.querySelector("#page_select_id");
                                        link_widget.push({
                                            page_name: e_2.options[e_2.selectedIndex].text,
                                        });
                                        console.log(e_2.options[e_2.selectedIndex].text);
                                        widget_add(e);
                                    }}
                                    className="btn_olustur_add_widget"
                                >
                                    Create
                                </button>
                            </>
                        ) : (
                            <>
                                <div className="choose_page_part">
                                    Choose Program
                                    <select
                                        style={{ maxWidth: "180px" }}
                                        name="page_select"
                                        id="page_select_id"
                                    >
                                        {props.pages_names.map((i, index) => {
                                            return (
                                                <option key={index} value={i}>
                                                    {i}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>

                                <button
                                    onClick={(e) => {
                                        Set_btn_widget_control("");
                                        document.querySelectorAll("#k-w-t").forEach((i) => {
                                            i.style.opacity = "0";
                                            i.style.zIndex = "-1000000000";
                                        });
                                        const widgets = document.querySelector(".link_widget");
                                        widgets.classList.toggle("link_widget_active");
                                        const widgets2 = document.querySelector(
                                            ".select_widget_type"
                                        );
                                        widgets2.style.opacity = "1";
                                        var e_2 = document.querySelector("#page_select_id");
                                        link_widget.push({
                                            page_name: e_2.options[e_2.selectedIndex].text,
                                        });
                                        console.log(e_2.options[e_2.selectedIndex].text);
                                        widget_add(e);
                                    }}
                                    className="btn_olustur_add_widget"
                                >
                                    Create
                                </button>
                            </>
                        )}
                    </div>
                    {
                        <div id="k-w-t" className="gauge_widget">
                            <i onClick={close_widget_add4} className="fa fa-times"></i>
                            <div className="gauge_part">
                                <div className="gauge_1">
                                    <GaugeChart
                                        id="gauge-chart"
                                        percent={Number(gaugeValue)}
                                        {...gaugeConfig}
                                    />
                                </div>
                                <div className="gauge_2">
                                    <div className="nokta">
                                        <h4>Tag</h4>
                                        <select
                                            style={{ maxWidth: "180px" }}
                                            name="gauge_select"
                                            id="gauge_select_id"
                                        >
                                            {props.tag_list.map((i, index) => {
                                                return (
                                                    <option key={index} value={i.tagId}>
                                                        {i.tagName}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                    <div className="max-Value">
                                        <h4>Max Value</h4>
                                        <input
                                            id="cm0-x7y"
                                            onChange={onChangeGaugeMax}
                                            value={gaugeValueMax}
                                            type="text"
                                            placeholder="max value"
                                        />
                                    </div>
                                </div>
                            </div>
                            <button
                                onClick={(e) => {
                                    var e_2 = document.querySelector("#gauge_select_id");
                                    var e_3 = document.querySelector("#cm0-x7y").value;
                                    if (String(e_3) !== "") {
                                        gaugeWidget.push({
                                            tagId: e_2.options[e_2.selectedIndex].value,
                                            max_value: Number(e_3),
                                        });
                                        SetTags((prevArray) => [
                                            ...prevArray,
                                            { tagId: e_2.options[e_2.selectedIndex].value },
                                        ]);
                                        tags_.push(e_2.options[e_2.selectedIndex].value);
                                    }
                                    var newdata = render_items;

                                    var newobj = {
                                        id: newdata.length - 1 + old_items3.length,
                                        x: Math.floor(Math.random() * 300),
                                        y: Math.floor(Math.random() * 300),
                                        type: "gauge",
                                        elementDetails: {
                                            tagName: e_2.options[e_2.selectedIndex].textContent,
                                            max_value: Number(e_3),
                                            tagId: e_2.options[e_2.selectedIndex].value,
                                        },
                                    };
                                    Set_items3((prevArray) => [...prevArray, newobj]);
                                    widget_add(e);
                                }}
                                className="btn_olustur_add_widget"
                            >
                                Create
                            </button>
                        </div>
                    }
                    {/* <div id='k-w-t' className="trend_widget">
                        <i onClick={close_widget_add5} className="fa fa-times"></i>
                        <div className="trend_part">
                            <div className='trend_1'>
                                <Line data={chartData} options={chartOptions} />
                            </div>
                            <div className="trend_2">
                                <div className="nokta">
                                    <h4>Tag</h4>
                                    <select style={{ maxWidth: "180px" }} name="trend_select" id="trend_select_id">{props.tag_list.map((i, index) => {
                                        return <option key={index} value={i.tagId}>{i.tagName}</option>
                                    })}</select>
                                </div>

                                <div className="y-label_axis">
                                    <h4>X-Axis Name:</h4>
                                    <input id='cm0-x7y-2' type="text" className='y-axis' placeholder='y-axis' />
                                </div>

                            </div>
                        </div>
                        <button onClick={(e) => {
                            var e_2 = document.querySelector("#trend_select_id")
                            var toplam = 0;
                            var e_4 = document.querySelectorAll("#cm0-x7y-2");
                            var e_6 = document.querySelector(".y-axis")
                            for (let i of e_4) {
                                if (i.value === "") {
                                    toplam++
                                }
                            }
                            if (toplam < 1) {
                                trends_widget.push({ "tagId": e_2.options[e_2.selectedIndex].value, "y_axis": e_6.value })
                                SetTags((prevArray) => [...prevArray, { "tagId": e_2.options[e_2.selectedIndex].value }])
                                tags_.push(e_2.options[e_2.selectedIndex].value)

                            } else {
                                alert("Değerleri eksiksiz girin!")
                            }

                            widget_add(e)
                        }} className="btn_olustur_add_widget">
                            Create
                        </button>
                    </div> */}
                    <div id="k-w-t" className="input_select_widget">
                        <i onClick={close_widget_add6} className="fa fa-times"></i>
                        <input
                            style={{ color: "rgb(34,34,34)", fontSize: "21px" }}
                            type="text"
                            value={main_title2}
                            onChange={add_main_title2}
                            placeholder="Main Title (optional)"
                        />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "80%",
                                marginBottom: "-12px",
                            }}
                        >
                            <div
                                style={{ width: "150px" }}
                                className={`dropdown ${isActive3 ? "active" : ""}`}
                                tabIndex="1"
                                onClick={handleDropdownClick3}
                                onBlur={handleDropdownBlur3}
                            >
                                <div className="select">
                                    <span>{selectedOption3}</span>
                                    <i className="fa fa-chevron-left"></i>
                                </div>
                                <input type="hidden" value={inputValue3} />
                                <ul style={{ width: "150px" }} className="dropdown-menu">
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick3(e.target.textContent);
                                        }}
                                        id={"1"}
                                        name={"start"}
                                        key={"1"}
                                    >
                                        {"Start"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick3(e.target.textContent);
                                        }}
                                        id={"2"}
                                        name={"BMS"}
                                        key={"2"}
                                    >
                                        {"BMS"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick3(e.target.textContent);
                                        }}
                                        id={"3"}
                                        name={"normal"}
                                        key={"3"}
                                    >
                                        {"Normal"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick3(e.target.textContent);
                                        }}
                                        id={"4"}
                                        name={"stop"}
                                        key={"4"}
                                    >
                                        {"Stop"}
                                    </li>
                                </ul>
                            </div>
                            <select
                                style={{
                                    maxWidth: "180px",
                                    padding: "12px 8px",
                                    position: "relative",
                                    left: "12px",
                                }}
                                name="select_value"
                                id="select_value_id_3"
                            >
                                {props.tag_list.map((i) => {
                                    return <option value={i.tagId}>{i.tagName}</option>;
                                })}
                            </select>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "80%",
                                marginBottom: "-12px",
                            }}
                        >
                            <div
                                style={{ width: "150px" }}
                                className={`dropdown ${isActive1 ? "active" : ""}`}
                                tabIndex="1"
                                onClick={handleDropdownClick1}
                                onBlur={handleDropdownBlur1}
                            >
                                <div className="select">
                                    <span>{selectedOption1}</span>
                                    <i className="fa fa-chevron-left"></i>
                                </div>
                                <input type="hidden" value={inputValue1} />
                                <ul style={{ width: "150px" }} className="dropdown-menu">
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick1(e.target.textContent);
                                        }}
                                        id={"1"}
                                        name={"start"}
                                        key={"1"}
                                    >
                                        {"Start"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick1(e.target.textContent);
                                        }}
                                        id={"2"}
                                        name={"BMS"}
                                        key={"2"}
                                    >
                                        {"BMS"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick1(e.target.textContent);
                                        }}
                                        id={"3"}
                                        name={"normal"}
                                        key={"3"}
                                    >
                                        {"Normal"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick1(e.target.textContent);
                                        }}
                                        id={"4"}
                                        name={"stop"}
                                        key={"4"}
                                    >
                                        {"Stop"}
                                    </li>
                                </ul>
                            </div>
                            <select
                                style={{
                                    maxWidth: "180px",
                                    padding: "12px 8px",
                                    position: "relative",
                                    left: "12px",
                                }}
                                name="select_value"
                                id="select_value_id_1"
                            >
                                {props.tag_list.map((i) => {
                                    return <option value={i.tagId}>{i.tagName}</option>;
                                })}
                            </select>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "80%",
                                marginBottom: "-12px",
                            }}
                        >
                            <div
                                style={{ width: "150px" }}
                                className={`dropdown ${isActive2 ? "active" : ""}`}
                                tabIndex="1"
                                onClick={handleDropdownClick2}
                                onBlur={handleDropdownBlur2}
                            >
                                <div className="select">
                                    <span>{selectedOption2}</span>
                                    <i className="fa fa-chevron-left"></i>
                                </div>
                                <input type="hidden" value={inputValue2} />
                                <ul style={{ width: "150px" }} className="dropdown-menu">
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick2(e.target.textContent);
                                        }}
                                        id={"1"}
                                        name={"start"}
                                        key={"1"}
                                    >
                                        {"Start"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick2(e.target.textContent);
                                        }}
                                        id={"2"}
                                        name={"BMS"}
                                        key={"2"}
                                    >
                                        {"BMS"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick2(e.target.textContent);
                                        }}
                                        id={"3"}
                                        name={"normal"}
                                        key={"3"}
                                    >
                                        {"Normal"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick2(e.target.textContent);
                                        }}
                                        id={"4"}
                                        name={"stop"}
                                        key={"4"}
                                    >
                                        {"Stop"}
                                    </li>
                                </ul>
                            </div>
                            <select
                                style={{
                                    maxWidth: "180px",
                                    padding: "12px 8px",
                                    position: "relative",
                                    left: "12px",
                                }}
                                name="select_value"
                                id="select_value_id_2"
                            >
                                {props.tag_list.map((i) => {
                                    return <option value={i.tagId}>{i.tagName}</option>;
                                })}
                            </select>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "80%",
                                marginBottom: "-12px",
                            }}
                        >
                            <div
                                style={{ width: "150px" }}
                                className={`dropdown ${isActive4 ? "active" : ""}`}
                                tabIndex="1"
                                onClick={handleDropdownClick4}
                                onBlur={handleDropdownBlur4}
                            >
                                <div className="select">
                                    <span>{selectedOption4}</span>
                                    <i className="fa fa-chevron-left"></i>
                                </div>
                                <input type="hidden" value={inputValue4} />
                                <ul style={{ width: "150px" }} className="dropdown-menu">
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick4(e.target.textContent);
                                        }}
                                        id={"1"}
                                        name={"start"}
                                        key={"1"}
                                    >
                                        {"Start"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick4(e.target.textContent);
                                        }}
                                        id={"2"}
                                        name={"BMS"}
                                        key={"2"}
                                    >
                                        {"BMS"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick4(e.target.textContent);
                                        }}
                                        id={"3"}
                                        name={"normal"}
                                        key={"3"}
                                    >
                                        {"Normal"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick4(e.target.textContent);
                                        }}
                                        id={"4"}
                                        name={"stop"}
                                        key={"4"}
                                    >
                                        {"Stop"}
                                    </li>
                                </ul>
                            </div>
                            <select
                                style={{
                                    maxWidth: "180px",
                                    padding: "12px 8px",
                                    position: "relative",
                                    left: "12px",
                                }}
                                name="select_value"
                                id="select_value_id_4"
                            >
                                {props.tag_list.map((i) => {
                                    return <option value={i.tagId}>{i.tagName}</option>;
                                })}
                            </select>
                        </div>

                        <button
                            onClick={async (e) => {
                                add_widget_plus2(e);
                                widget_add(e);
                            }}
                            className="btn_olustur_add_widget"
                        >
                            Create
                        </button>
                    </div>
                    {/* <div id="k-w-t" className='manuel_widget'>
                    <i onClick={close_widget_add7} className="fa fa-times"></i>
                    <div className="row">
                        <input type="text" className="input1" />
                        <input type="text" className="input2" />
                    </div>
                    <div className="row">
                        <input type="text" className="input1" />
                        <input type="text" className="input2" />
                    </div>
                    <div className="row"></div>
                    <div className="row"></div>
                    <div className="row"></div>

                    <button onClick={async (e) => {
                        add_widget_plus2(e)
                        widget_add(e)
                    }
                    } className="btn_olustur_add_widget">
                        Create
                    </button>
                </div> */}

                    <div className="vrf_detail_popup">
                        <div>
                            {pop_up_widget.map((item, index) => {
                                console.log(item);
                                if ((String(item.id)) === String(pop_up_id)) {
                                    return (
                                        <div className="card-body_white_paper white_space">
                                            <i onClick={close_vrf_pop_up} style={{ cursor: "pointer", backgroundColor: "white", borderRadius: "26px", width: "26px", height: "26px", padding: "4px", display: "flex", alignItems: "center", marginBottom: "8px", justifyContent: "center", position: "relative", cursor: "pointer", left: "93%", top: "-260px", color: "red", fontWeight: "600", fontSize: "22px", cursor: "pointer" }} className="fa fa-times"></i>
                                            <div id={item.id} className="white_paper_xs_3_big">

                                                <div>
                                                    {item.elementDetails.map((item, index) => {
                                                        console.log(item);
                                                        if (item.type === "text") {
                                                            return (
                                                                <Draggable
                                                                    position={{ x: item.x, y: item.y }}
                                                                    disabled={true}
                                                                >
                                                                    <div id={item.id}>
                                                                        <input
                                                                            style={{
                                                                                backgroundColor: "white",
                                                                                width: "40%",
                                                                            }}
                                                                            type="text"
                                                                            className="drag-input-text"
                                                                            value={item.elementDetails.text}
                                                                        />
                                                                    </div>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "title") {
                                                            console.log(item);
                                                            return (
                                                                <Draggable
                                                                    disabled={true}
                                                                    position={{ x: item.x, y: item.y }}
                                                                >
                                                                    <div id={item.id}>
                                                                        <input
                                                                            style={{
                                                                                backgroundColor: "white",
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let data_new = items3;
                                                                                data_new.forEach((i) => {
                                                                                    if (
                                                                                        String(i.id) ===
                                                                                        e.target.parentElement.id
                                                                                    ) {
                                                                                        i.elementDetails.text =
                                                                                            e.target.value;
                                                                                    }
                                                                                });
                                                                                Set_items3(data_new);
                                                                            }}
                                                                            type="text"
                                                                            value={
                                                                                item.elementDetails.text !==
                                                                                    ""
                                                                                    ? item.elementDetails.text
                                                                                    : undefined
                                                                            }
                                                                            className="drag-input-title"
                                                                        />
                                                                    </div>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "label") {
                                                            return (
                                                                <Draggable
                                                                    position={{ x: item.x, y: item.y }}
                                                                    disabled={true}
                                                                >
                                                                    <div
                                                                        id={item.id}
                                                                        className="main_label"
                                                                    >
                                                                        {item.main_title !== "" ? (
                                                                            <h5
                                                                                style={{
                                                                                    display: "block",
                                                                                    height: "20px",
                                                                                    margin: "0",
                                                                                }}
                                                                                className="main_titile_label_widget"
                                                                            >
                                                                                {item.main_title}
                                                                            </h5>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                        <span>
                                                                            {item.text}{" "}
                                                                            {item.led === "true" ? (
                                                                                <input
                                                                                    className="led_checkbox"
                                                                                    type="checkbox"
                                                                                />
                                                                            ) : (
                                                                                <input
                                                                                    className="led_checkbox"
                                                                                    type="checkbox"
                                                                                    style={{
                                                                                        backgroundColor: "red",
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </span>
                                                                        <div
                                                                            style={{ height: "auto" }}
                                                                            className="proggress_bar_default"
                                                                        >
                                                                            <div
                                                                                title={`Değer: 100`}
                                                                                style={{
                                                                                    textAlign: "center",
                                                                                    color: "white",
                                                                                    padding: "8px 0",
                                                                                    fontWeight: "600",
                                                                                    height: "100%",
                                                                                    fontSize: "11px",
                                                                                    backgroundColor: "red",
                                                                                    width: `60%`,
                                                                                    borderRadius: "8px",
                                                                                }}
                                                                            >
                                                                                100
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "led") {
                                                            let color = "green";
                                                            if (item.elementDetails.color) {
                                                                color = item.elementDetails.color;
                                                            }
                                                            return (
                                                                <Draggable
                                                                    position={{ x: item.x, y: item.y }}
                                                                    disabled={true}
                                                                >
                                                                    <div id={item.id}>
                                                                        <input
                                                                            style={{
                                                                                backgroundColor: color,
                                                                            }}
                                                                            type="checkbox"
                                                                            id="white_space_led"
                                                                        />
                                                                    </div>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "gauge") {
                                                            var percent = Number(

                                                                Number(props.tag_values.filter((x) => String(x.tagId) === String(item.elementDetails.tagId)).map((x) =>
                                                                    Number(x.tagValue.replaceAll(",", ".")).toFixed(2))) / Number(item.elementDetails.max_value)
                                                            );
                                                            var değer = props.tag_values
                                                                .filter(
                                                                    (x) =>
                                                                        String(x.tagId) ===
                                                                        String(item.elementDetails.tagId)
                                                                )
                                                                .map((x) =>
                                                                    Number(
                                                                        x.tagValue.replaceAll(",", ".")
                                                                    ).toFixed(2)
                                                                );
                                                            console.log(percent, değer);
                                                            return (
                                                                <div>
                                                                    <Draggable
                                                                        disabled={true}
                                                                        position={{
                                                                            x: item.x,
                                                                            y: item.y,
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="gauge_widget_tool"
                                                                            id={item.id}
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    maxWidth: "100px",
                                                                                    backgroundColor:
                                                                                        "rgb(240,240,240)",
                                                                                    border:
                                                                                        "2px solid rgb(40,40,40)",
                                                                                    padding: "4px 0px",
                                                                                }}
                                                                                className="gauge_widget_tool"
                                                                                id={item.id}
                                                                            >
                                                                                <GaugeChart
                                                                                    style={{
                                                                                        maxWidth: "100px",
                                                                                    }}
                                                                                    arcColor={getGaugeColor(
                                                                                        percent
                                                                                    )}
                                                                                    id="gauge-chart"
                                                                                    percent={percent}
                                                                                    {...gaugeConfig}
                                                                                />
                                                                                <div className="gauge_values_display_page_toolbox">
                                                                                    <span>0</span>
                                                                                    <span>{değer}</span>
                                                                                    <span>
                                                                                        {
                                                                                            item.elementDetails
                                                                                                .max_value
                                                                                        }
                                                                                    </span>
                                                                                </div>
                                                                                <span className="w_gauge_name_tag">{item.elementDetails.tagName}</span>
                                                                            </div>
                                                                        </div>
                                                                    </Draggable>
                                                                </div>
                                                            );
                                                        }
                                                        if (item.type === "button") {
                                                            return (
                                                                <Draggable
                                                                    disabled={true}
                                                                    position={{ x: item.x, y: item.y }}
                                                                >
                                                                    <select
                                                                        id={item.id}
                                                                        name="button_link_select"
                                                                        className="button_link_select"
                                                                    >
                                                                        {props.pages.map((item) => {
                                                                            return (
                                                                                <option value={index}>
                                                                                    {item.pageName}
                                                                                </option>
                                                                            );
                                                                        })}
                                                                    </select>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "select") {
                                                            return (
                                                                <Draggable
                                                                    position={{ x: item.x, y: item.y }}
                                                                    disabled={true}
                                                                >
                                                                    <div id={item.id}>
                                                                        <select
                                                                            name="tag_select"
                                                                            id="tag_select"
                                                                        >
                                                                            <option
                                                                                key={"1"}
                                                                                value={item.elementDetails.id}
                                                                            >
                                                                                {item.elementDetails.text}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "text_box") {
                                                            return (
                                                                <Draggable
                                                                    disabled={true}
                                                                    position={{ x: item.x, y: item.y }}
                                                                >
                                                                    <span
                                                                        id={item.id}
                                                                        className="w_text_box_span"
                                                                    >
                                                                        <input
                                                                            value={item.elementDetails.text}
                                                                            disabled={true}
                                                                            className="w_text_box_inp"
                                                                        />
                                                                    </span>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "tag") {
                                                            var değer = props.tag_values.filter(x => String(x.tagId) === String(item.elementDetails.tagId)).map(x => Number(x.tagValue.replaceAll(",", ".")).toFixed(2))

                                                            return <Draggable disabled={true} position={{ x: item.x, y: item.y }}>
                                                                <div className={`tag_${item.id}`} id={item.id}>
                                                                    <div className="tag_ws3">
                                                                        <p style={{ marginRight: "12px" }}>{item.elementDetails.text}</p>
                                                                        <p className='p_tag_value_TAG'>{değer}</p>

                                                                    </div>
                                                                </div>

                                                            </Draggable>
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                            })}

                        </div>
                    </div>



                </main>
            )}
        </>
    );
};

const MapStateToProps = (state) => {
    return {
        pages: state.project_reducer.pages,
        pages_names: state.project_reducer.pages_names,
        auth_reducer: state.auth_reducer.user_id,
        profile: state.project_reducer.profile_infos,
        company_id: state.project_reducer.company_id,
        secret_key: state.project_reducer.secret_key_db_firebase,
        tag_list: state.project_reducer.tag_list,
        current_path: state.project_reducer.current_path,
        toolbox: state.project_reducer.toolbox_items,
        white_space_: state.project_reducer.white_space_items,
        render_items_length: state.project_reducer.render_toolbox_items,
        _tag_ids: state.project_reducer.tag_ids,
        tag_values: state.project_reducer.tag_values,
        white_space_3: state.project_reducer.pop_up_widget,

    };
};

export default connect(MapStateToProps)(All3);